export const languageCNMap = {
  languages: {
    aa: "阿法尔语",
    ab: "阿布哈西亚语",
    ace: "亚齐语",
    ach: "阿乔利语",
    ada: "阿当梅语",
    ady: "阿迪格语",
    ae: "阿维斯塔语",
    af: "南非荷兰语",
    afh: "阿弗里希利语",
    agq: "亚罕语",
    ain: "阿伊努语",
    ak: "阿肯语",
    akk: "阿卡德语",
    ale: "阿留申语",
    alt: "南阿尔泰语",
    am: "阿姆哈拉语",
    an: "阿拉贡语",
    ang: "古英语",
    ann: "奥博洛语",
    anp: "昂加语",
    ar: "阿拉伯语",
    "ar-001": "现代标准阿拉伯语",
    arc: "阿拉米语",
    arn: "马普切语",
    arp: "阿拉帕霍语",
    ars: "纳吉迪阿拉伯语",
    "ars-alt-menu": "阿拉伯语（纳吉迪）",
    arw: "阿拉瓦克语",
    as: "阿萨姆语",
    asa: "帕雷语",
    ast: "阿斯图里亚斯语",
    atj: "阿提卡米克语",
    av: "阿瓦尔语",
    awa: "阿瓦德语",
    ay: "艾马拉语",
    az: "阿塞拜疆语",
    "az-alt-short": "阿塞语",
    "az-Arab": "南阿塞拜疆语",
    ba: "巴什基尔语",
    bal: "俾路支语",
    ban: "巴厘语",
    bas: "巴萨语",
    bax: "巴姆穆语",
    bbj: "戈马拉语",
    be: "白俄罗斯语",
    bej: "贝沙语",
    bem: "本巴语",
    bez: "贝纳语",
    bfd: "巴非特语",
    bg: "保加利亚语",
    bgc: "哈里亚纳语",
    bgn: "西俾路支语",
    bho: "博杰普尔语",
    bi: "比斯拉马语",
    bik: "比科尔语",
    bin: "比尼语",
    bkm: "科姆语",
    bla: "西克西卡语",
    blo: "阿尼语",
    bm: "班巴拉语",
    bn: "孟加拉语",
    bo: "藏语",
    br: "布列塔尼语",
    bra: "布拉杰语",
    brx: "博多语",
    bs: "波斯尼亚语",
    bss: "阿库色语",
    bua: "布里亚特语",
    bug: "布吉语",
    bum: "布鲁语",
    byn: "比林语",
    byv: "梅敦巴语",
    ca: "加泰罗尼亚语",
    cad: "卡多语",
    car: "加勒比语",
    cay: "卡尤加语",
    cch: "阿灿语",
    ccp: "查克玛语",
    ce: "车臣语",
    ceb: "宿务语",
    cgg: "奇加语",
    ch: "查莫罗语",
    chb: "奇布查语",
    chg: "察合台语",
    chk: "楚克语",
    chm: "马里语",
    chn: "奇努克混合语",
    cho: "乔克托语",
    chp: "奇佩维安语",
    chr: "切罗基语",
    chy: "夏延语",
    ckb: "中库尔德语",
    "ckb-alt-variant": "索拉尼库尔德语",
    clc: "奇尔科廷语",
    co: "科西嘉语",
    cop: "科普特语",
    cr: "克里语",
    crg: "米其芙语",
    crh: "克里米亚鞑靼语",
    crj: "东南部克里语",
    crk: "平原克里语",
    crl: "东北部克里语",
    crm: "穆斯克里语",
    crr: "卡罗莱纳州阿尔冈昆语",
    crs: "塞舌尔克里奥尔语",
    cs: "捷克语",
    csb: "卡舒比语",
    csw: "沼泽克里语",
    cu: "教会斯拉夫语",
    cv: "楚瓦什语",
    cy: "威尔士语",
    da: "丹麦语",
    dak: "达科他语",
    dar: "达尔格瓦语",
    dav: "台塔语",
    de: "德语",
    "de-AT": "奥地利德语",
    "de-CH": "瑞士高地德语",
    del: "特拉华语",
    den: "史拉维语",
    dgr: "多格里布语",
    din: "丁卡语",
    dje: "哲尔马语",
    doi: "多格拉语",
    dsb: "下索布语",
    dua: "杜阿拉语",
    dum: "中古荷兰语",
    dv: "迪维希语",
    dyo: "朱拉语",
    dyu: "迪尤拉语",
    dz: "宗卡语",
    dzg: "达扎葛语",
    ebu: "恩布语",
    ee: "埃维语",
    efi: "埃菲克语",
    egy: "古埃及语",
    eka: "艾卡朱克语",
    el: "希腊语",
    elx: "埃兰语",
    en: "英语",
    "en-AU": "澳大利亚英语",
    "en-CA": "加拿大英语",
    "en-GB": "英国英语",
    "en-GB-alt-short": "英式英语",
    "en-US": "美国英语",
    "en-US-alt-short": "美式英语",
    enm: "中古英语",
    eo: "世界语",
    es: "西班牙语",
    "es-419": "拉丁美洲西班牙语",
    "es-ES": "欧洲西班牙语",
    "es-MX": "墨西哥西班牙语",
    et: "爱沙尼亚语",
    eu: "巴斯克语",
    ewo: "埃翁多语",
    fa: "波斯语",
    "fa-AF": "达里语",
    fan: "芳格语",
    fat: "芳蒂语",
    ff: "富拉语",
    fi: "芬兰语",
    fil: "菲律宾语",
    fj: "斐济语",
    fo: "法罗语",
    fon: "丰语",
    fr: "法语",
    "fr-CA": "加拿大法语",
    "fr-CH": "瑞士法语",
    frc: "卡真法语",
    frm: "中古法语",
    fro: "古法语",
    frr: "北弗里西亚语",
    frs: "东弗里西亚语",
    fur: "弗留利语",
    fy: "西弗里西亚语",
    ga: "爱尔兰语",
    gaa: "加族语",
    gag: "加告兹语",
    gan: "赣语",
    gay: "迦约语",
    gba: "格巴亚语",
    gd: "苏格兰盖尔语",
    gez: "吉兹语",
    gil: "吉尔伯特语",
    gl: "加利西亚语",
    gmh: "中古高地德语",
    gn: "瓜拉尼语",
    goh: "古高地德语",
    gon: "冈德语",
    gor: "哥伦打洛语",
    got: "哥特语",
    grb: "格列博语",
    grc: "古希腊语",
    gsw: "瑞士德语",
    gu: "古吉拉特语",
    guz: "古西语",
    gv: "马恩语",
    gwi: "哥威迅语",
    ha: "豪萨语",
    hai: "海达语",
    hak: "客家语",
    haw: "夏威夷语",
    hax: "南海达语",
    he: "希伯来语",
    hi: "印地语",
    "hi-Latn": "印地语（拉丁字母）",
    "hi-Latn-alt-variant": "印地英语",
    hil: "希利盖农语",
    hit: "赫梯语",
    hmn: "苗语",
    ho: "希里莫图语",
    hr: "克罗地亚语",
    hsb: "上索布语",
    hsn: "湘语",
    ht: "海地克里奥尔语",
    hu: "匈牙利语",
    hup: "胡帕语",
    hur: "哈尔魁梅林语",
    hy: "亚美尼亚语",
    hz: "赫雷罗语",
    ia: "国际语",
    iba: "伊班语",
    ibb: "伊比比奥语",
    id: "印度尼西亚语",
    ie: "国际文字（E）",
    ig: "伊博语",
    ii: "凉山彝语",
    ik: "伊努皮克语",
    ikt: "西加拿大因纽特语",
    ilo: "伊洛卡诺语",
    inh: "印古什语",
    io: "伊多语",
    is: "冰岛语",
    it: "意大利语",
    iu: "因纽特语",
    ja: "日语",
    jbo: "逻辑语",
    jgo: "恩艮巴语",
    jmc: "马切姆语",
    jpr: "犹太波斯语",
    jrb: "犹太阿拉伯语",
    jv: "爪哇语",
    ka: "格鲁吉亚语",
    kaa: "卡拉卡尔帕克语",
    kab: "卡拜尔语",
    kac: "克钦语",
    kaj: "卡捷语",
    kam: "卡姆巴语",
    kaw: "卡威语",
    kbd: "卡巴尔德语",
    kbl: "加涅姆布语",
    kcg: "卡塔布语",
    kde: "马孔德语",
    kea: "卡布佛得鲁语",
    kfo: "克罗语",
    kg: "刚果语",
    kgp: "坎刚语",
    kha: "卡西语",
    kho: "和田语",
    khq: "西桑海语",
    ki: "吉库尤语",
    kj: "宽亚玛语",
    kk: "哈萨克语",
    kkj: "卡库语",
    kl: "格陵兰语",
    kln: "卡伦金语",
    km: "高棉语",
    kmb: "金邦杜语",
    kn: "卡纳达语",
    ko: "韩语",
    koi: "科米-彼尔米亚克语",
    kok: "孔卡尼语",
    kos: "科斯拉伊语",
    kpe: "克佩列语",
    kr: "卡努里语",
    krc: "卡拉恰伊巴尔卡尔语",
    krl: "卡累利阿语",
    kru: "库鲁克语",
    ks: "克什米尔语",
    ksb: "香巴拉语",
    ksf: "巴菲亚语",
    ksh: "科隆语",
    ku: "库尔德语",
    kum: "库梅克语",
    kut: "库特奈语",
    kv: "科米语",
    kw: "康沃尔语",
    kwk: "夸夸瓦拉语",
    kxv: "库维语",
    ky: "柯尔克孜语",
    la: "拉丁语",
    lad: "拉迪诺语",
    lag: "朗吉语",
    lah: "西旁遮普语",
    lam: "兰巴语",
    lb: "卢森堡语",
    lez: "列兹金语",
    lg: "卢干达语",
    li: "林堡语",
    lij: "利古里亚语",
    lil: "利洛埃特语",
    lkt: "拉科塔语",
    lmo: "伦巴第语",
    ln: "林加拉语",
    lo: "老挝语",
    lol: "蒙戈语",
    lou: "路易斯安那克里奥尔语",
    loz: "洛齐语",
    lrc: "北卢尔语",
    lsm: "萨米亚语",
    lt: "立陶宛语",
    lu: "鲁巴加丹加语",
    lua: "卢巴-卢拉语",
    lui: "卢伊塞诺语",
    lun: "隆达语",
    luo: "卢奥语",
    lus: "米佐语",
    luy: "卢雅语",
    lv: "拉脱维亚语",
    mad: "马都拉语",
    maf: "马法语",
    mag: "摩揭陀语",
    mai: "迈蒂利语",
    mak: "望加锡语",
    man: "曼丁哥语",
    mas: "马赛语",
    mde: "马坝语",
    mdf: "莫克沙语",
    mdr: "曼达尔语",
    men: "门德语",
    mer: "梅鲁语",
    mfe: "毛里求斯克里奥尔语",
    mg: "马拉加斯语",
    mga: "中古爱尔兰语",
    mgh: "马库阿-梅托语",
    mgo: "梅塔语",
    mh: "马绍尔语",
    mi: "毛利语",
    mic: "密克马克语",
    min: "米南佳保语",
    mk: "马其顿语",
    ml: "马拉雅拉姆语",
    mn: "蒙古语",
    mnc: "满语",
    mni: "曼尼普尔语",
    moe: "因努埃蒙语",
    moh: "摩霍克语",
    mos: "莫西语",
    mr: "马拉地语",
    ms: "马来语",
    mt: "马耳他语",
    mua: "蒙当语",
    mul: "多语种",
    mus: "克里克语",
    mwl: "米兰德斯语",
    mwr: "马尔瓦里语",
    my: "缅甸语",
    mye: "姆耶内语",
    myv: "厄尔兹亚语",
    mzn: "马赞德兰语",
    na: "瑙鲁语",
    nan: "闽南语",
    nap: "那不勒斯语",
    naq: "纳马语",
    nb: "书面挪威语",
    nd: "北恩德贝勒语",
    nds: "低地德语",
    "nds-NL": "低萨克森语",
    ne: "尼泊尔语",
    new: "尼瓦尔语",
    ng: "恩东加语",
    nia: "尼亚斯语",
    niu: "纽埃语",
    nl: "荷兰语",
    "nl-BE": "弗拉芒语",
    nmg: "夸西奥语",
    nn: "挪威尼诺斯克语",
    nnh: "恩甘澎语",
    no: "挪威语",
    nog: "诺盖语",
    non: "古诺尔斯语",
    nqo: "西非书面文字",
    nr: "南恩德贝勒语",
    nso: "北索托语",
    nus: "努埃尔语",
    nv: "纳瓦霍语",
    nwc: "古典尼瓦尔语",
    ny: "齐切瓦语",
    nym: "尼扬韦齐语",
    nyn: "尼昂科勒语",
    nyo: "尼奥罗语",
    nzi: "恩济马语",
    oc: "奥克语",
    oj: "奥吉布瓦语",
    ojb: "西北部奥吉布瓦语",
    ojc: "中奥吉布瓦语",
    ojs: "欧吉克里语",
    ojw: "西奥吉布瓦语",
    oka: "欧肯那根语",
    om: "奥罗莫语",
    or: "奥里亚语",
    os: "奥塞梯语",
    osa: "欧塞奇语",
    ota: "奥斯曼土耳其语",
    pa: "旁遮普语",
    pag: "邦阿西南语",
    pal: "巴拉维语",
    pam: "邦板牙语",
    pap: "帕皮阿门托语",
    pau: "帕劳语",
    pcm: "尼日利亚皮钦语",
    peo: "古波斯语",
    phn: "腓尼基语",
    pi: "巴利语",
    pis: "皮京语",
    pl: "波兰语",
    pon: "波纳佩语",
    pqm: "马利塞-帕萨马科迪语",
    prg: "普鲁士语",
    pro: "古普罗文斯语",
    ps: "普什图语",
    pt: "葡萄牙语",
    "pt-BR": "巴西葡萄牙语",
    "pt-PT": "欧洲葡萄牙语",
    qu: "克丘亚语",
    quc: "基切语",
    raj: "拉贾斯坦语",
    rap: "拉帕努伊语",
    rar: "拉罗汤加语",
    rhg: "罗兴亚语",
    rif: "里夫语",
    rm: "罗曼什语",
    rn: "隆迪语",
    ro: "罗马尼亚语",
    "ro-MD": "摩尔多瓦语",
    rof: "兰博语",
    rom: "吉普赛语",
    ru: "俄语",
    rup: "阿罗马尼亚语",
    rw: "卢旺达语",
    rwk: "罗瓦语",
    sa: "梵语",
    sad: "桑达韦语",
    sah: "萨哈语",
    sam: "萨马利亚阿拉姆语",
    saq: "桑布鲁语",
    sas: "萨萨克语",
    sat: "桑塔利语",
    sba: "甘拜语",
    sbp: "桑古语",
    sc: "萨丁语",
    scn: "西西里语",
    sco: "苏格兰语",
    sd: "信德语",
    sdh: "南库尔德语",
    se: "北方萨米语",
    see: "塞内卡语",
    seh: "塞纳语",
    sel: "塞尔库普语",
    ses: "东桑海语",
    sg: "桑戈语",
    sga: "古爱尔兰语",
    sh: "塞尔维亚-克罗地亚语",
    shi: "希尔哈语",
    shn: "掸语",
    shu: "乍得阿拉伯语",
    si: "僧伽罗语",
    sid: "悉达摩语",
    sk: "斯洛伐克语",
    skr: "色莱基语",
    sl: "斯洛文尼亚语",
    slh: "南卢舒特种子语",
    sm: "萨摩亚语",
    sma: "南萨米语",
    smj: "吕勒萨米语",
    smn: "伊纳里萨米语",
    sms: "斯科特萨米语",
    sn: "绍纳语",
    snk: "索宁克语",
    so: "索马里语",
    sog: "粟特语",
    sq: "阿尔巴尼亚语",
    sr: "塞尔维亚语",
    srn: "苏里南汤加语",
    srr: "塞雷尔语",
    ss: "斯瓦蒂语",
    ssy: "萨霍语",
    st: "南索托语",
    str: "海峡萨利希语",
    su: "巽他语",
    suk: "苏库马语",
    sus: "苏苏语",
    sux: "苏美尔语",
    sv: "瑞典语",
    sw: "斯瓦希里语",
    "sw-CD": "刚果斯瓦希里语",
    swb: "科摩罗语",
    syc: "古典叙利亚语",
    syr: "叙利亚语",
    szl: "西里西亚语",
    ta: "泰米尔语",
    tce: "南塔穹语",
    te: "泰卢固语",
    tem: "泰姆奈语",
    teo: "特索语",
    ter: "特伦诺语",
    tet: "德顿语",
    tg: "塔吉克语",
    tgx: "塔吉什语",
    th: "泰语",
    tht: "塔尔坦语",
    ti: "提格利尼亚语",
    tig: "提格雷语",
    tiv: "蒂夫语",
    tk: "土库曼语",
    tkl: "托克劳语",
    tl: "他加禄语",
    tlh: "克林贡语",
    tli: "特林吉特语",
    tmh: "塔马奇克语",
    tn: "茨瓦纳语",
    to: "汤加语",
    tog: "尼亚萨汤加语",
    tok: "道本语",
    tpi: "托克皮辛语",
    tr: "土耳其语",
    trv: "赛德克语",
    trw: "托尔瓦利语",
    ts: "聪加语",
    tsi: "钦西安语",
    tt: "鞑靼语",
    ttm: "北塔穹语",
    tum: "通布卡语",
    tvl: "图瓦卢语",
    tw: "契维语",
    twq: "北桑海语",
    ty: "塔希提语",
    tyv: "图瓦语",
    tzm: "塔马齐格特语",
    udm: "乌德穆尔特语",
    ug: "维吾尔语",
    uga: "乌加里特语",
    uk: "乌克兰语",
    umb: "翁本杜语",
    und: "未知语言",
    ur: "乌尔都语",
    uz: "乌兹别克语",
    vai: "瓦伊语",
    ve: "文达语",
    vec: "威尼斯语",
    vep: "维普森语",
    vi: "越南语",
    vmw: "马库阿语",
    vo: "沃拉普克语",
    vot: "沃提克语",
    vun: "温旧语",
    wa: "瓦隆语",
    wae: "瓦尔瑟语",
    wal: "瓦拉莫语",
    war: "瓦瑞语",
    was: "瓦绍语",
    wbp: "瓦尔皮瑞语",
    wo: "沃洛夫语",
    wuu: "吴语",
    xal: "卡尔梅克语",
    xh: "科萨语",
    xnr: "康格里语",
    xog: "索加语",
    yao: "尧语",
    yap: "雅浦语",
    yav: "洋卞语",
    ybb: "耶姆巴语",
    yi: "意第绪语",
    yo: "约鲁巴语",
    yrl: "恩加图语",
    yue: "粤语",
    "yue-alt-menu": "广东话",
    za: "壮语",
    zap: "萨波蒂克语",
    zbl: "布里斯符号",
    zen: "泽纳加语",
    zgh: "标准摩洛哥塔马塞特语",
    zh: "中文",
    "zh-alt-menu": "普通话",
    "zh-Hans": "简体中文",
    "zh-Hans-alt-long": "现代标准汉语（简体）",
    "zh-Hant": "繁体中文",
    "zh-Hant-alt-long": "现代标准汉语（繁体）",
    zu: "祖鲁语",
    zun: "祖尼语",
    zxx: "无语言内容",
    zza: "扎扎语",
  },
  territories: {
    "001": "世界",
    "002": "非洲",
    "003": "北美洲",
    "005": "南美洲",
    "009": "大洋洲",
    "011": "西非",
    "013": "中美洲",
    "014": "东非",
    "015": "北非",
    "017": "中非",
    "018": "南部非洲",
    "019": "美洲",
    "021": "美洲北部",
    "029": "加勒比地区",
    "030": "东亚",
    "034": "南亚",
    "035": "东南亚",
    "039": "南欧",
    "053": "澳大拉西亚",
    "054": "美拉尼西亚",
    "057": "密克罗尼西亚地区",
    "061": "玻利尼西亚",
    "142": "亚洲",
    "143": "中亚",
    "145": "西亚",
    "150": "欧洲",
    "151": "东欧",
    "154": "北欧",
    "155": "西欧",
    "202": "撒哈拉以南非洲",
    "419": "拉丁美洲",
    AC: "阿森松岛",
    AD: "安道尔",
    AE: "阿拉伯联合酋长国",
    AF: "阿富汗",
    AG: "安提瓜和巴布达",
    AI: "安圭拉",
    AL: "阿尔巴尼亚",
    AM: "亚美尼亚",
    AO: "安哥拉",
    AQ: "南极洲",
    AR: "阿根廷",
    AS: "美属萨摩亚",
    AT: "奥地利",
    AU: "澳大利亚",
    AW: "阿鲁巴",
    AX: "奥兰群岛",
    AZ: "阿塞拜疆",
    BA: "波斯尼亚和黑塞哥维那",
    BB: "巴巴多斯",
    BD: "孟加拉国",
    BE: "比利时",
    BF: "布基纳法索",
    BG: "保加利亚",
    BH: "巴林",
    BI: "布隆迪",
    BJ: "贝宁",
    BL: "圣巴泰勒米",
    BM: "百慕大",
    BN: "文莱",
    BO: "玻利维亚",
    BQ: "荷属加勒比区",
    BR: "巴西",
    BS: "巴哈马",
    BT: "不丹",
    BV: "布韦岛",
    BW: "博茨瓦纳",
    BY: "白俄罗斯",
    BZ: "伯利兹",
    CA: "加拿大",
    CC: "科科斯（基林）群岛",
    CD: "刚果（金）",
    "CD-alt-variant": "刚果民主共和国",
    CF: "中非共和国",
    CG: "刚果（布）",
    "CG-alt-variant": "刚果共和国",
    CH: "瑞士",
    CI: "科特迪瓦",
    "CI-alt-variant": "象牙海岸",
    CK: "库克群岛",
    CL: "智利",
    CM: "喀麦隆",
    CN: "中国",
    CO: "哥伦比亚",
    CP: "克利珀顿岛",
    CR: "哥斯达黎加",
    CU: "古巴",
    CV: "佛得角",
    CW: "库拉索",
    CX: "圣诞岛",
    CY: "塞浦路斯",
    CZ: "捷克",
    "CZ-alt-variant": "捷克共和国",
    DE: "德国",
    DG: "迪戈加西亚岛",
    DJ: "吉布提",
    DK: "丹麦",
    DM: "多米尼克",
    DO: "多米尼加共和国",
    DZ: "阿尔及利亚",
    EA: "休达及梅利利亚",
    EC: "厄瓜多尔",
    EE: "爱沙尼亚",
    EG: "埃及",
    EH: "西撒哈拉",
    ER: "厄立特里亚",
    ES: "西班牙",
    ET: "埃塞俄比亚",
    EU: "欧盟",
    EZ: "欧元区",
    FI: "芬兰",
    FJ: "斐济",
    FK: "福克兰群岛",
    "FK-alt-variant": "福克兰群岛（马尔维纳斯群岛）",
    FM: "密克罗尼西亚",
    FO: "法罗群岛",
    FR: "法国",
    GA: "加蓬",
    GB: "英国",
    GD: "格林纳达",
    GE: "格鲁吉亚",
    GF: "法属圭亚那",
    GG: "根西岛",
    GH: "加纳",
    GI: "直布罗陀",
    GL: "格陵兰",
    GM: "冈比亚",
    GN: "几内亚",
    GP: "瓜德罗普",
    GQ: "赤道几内亚",
    GR: "希腊",
    GS: "南乔治亚和南桑威奇群岛",
    GT: "危地马拉",
    GU: "关岛",
    GW: "几内亚比绍",
    GY: "圭亚那",
    HK: "中国香港特别行政区",
    "HK-alt-short": "香港",
    HM: "赫德岛和麦克唐纳群岛",
    HN: "洪都拉斯",
    HR: "克罗地亚",
    HT: "海地",
    HU: "匈牙利",
    IC: "加纳利群岛",
    ID: "印度尼西亚",
    IE: "爱尔兰",
    IL: "以色列",
    IM: "马恩岛",
    IN: "印度",
    IO: "英属印度洋领地",
    "IO-alt-chagos": "查戈斯群岛",
    IQ: "伊拉克",
    IR: "伊朗",
    IS: "冰岛",
    IT: "意大利",
    JE: "泽西岛",
    JM: "牙买加",
    JO: "约旦",
    JP: "日本",
    KE: "肯尼亚",
    KG: "吉尔吉斯斯坦",
    KH: "柬埔寨",
    KI: "基里巴斯",
    KM: "科摩罗",
    KN: "圣基茨和尼维斯",
    KP: "朝鲜",
    KR: "韩国",
    KW: "科威特",
    KY: "开曼群岛",
    KZ: "哈萨克斯坦",
    LA: "老挝",
    LB: "黎巴嫩",
    LC: "圣卢西亚",
    LI: "列支敦士登",
    LK: "斯里兰卡",
    LR: "利比里亚",
    LS: "莱索托",
    LT: "立陶宛",
    LU: "卢森堡",
    LV: "拉脱维亚",
    LY: "利比亚",
    MA: "摩洛哥",
    MC: "摩纳哥",
    MD: "摩尔多瓦",
    ME: "黑山",
    MF: "法属圣马丁",
    MG: "马达加斯加",
    MH: "马绍尔群岛",
    MK: "北马其顿",
    ML: "马里",
    MM: "缅甸",
    MN: "蒙古",
    MO: "中国澳门特别行政区",
    "MO-alt-short": "澳门",
    MP: "北马里亚纳群岛",
    MQ: "马提尼克",
    MR: "毛里塔尼亚",
    MS: "蒙特塞拉特",
    MT: "马耳他",
    MU: "毛里求斯",
    MV: "马尔代夫",
    MW: "马拉维",
    MX: "墨西哥",
    MY: "马来西亚",
    MZ: "莫桑比克",
    NA: "纳米比亚",
    NC: "新喀里多尼亚",
    NE: "尼日尔",
    NF: "诺福克岛",
    NG: "尼日利亚",
    NI: "尼加拉瓜",
    NL: "荷兰",
    NO: "挪威",
    NP: "尼泊尔",
    NR: "瑙鲁",
    NU: "纽埃",
    NZ: "新西兰",
    OM: "阿曼",
    PA: "巴拿马",
    PE: "秘鲁",
    PF: "法属波利尼西亚",
    PG: "巴布亚新几内亚",
    PH: "菲律宾",
    PK: "巴基斯坦",
    PL: "波兰",
    PM: "圣皮埃尔和密克隆群岛",
    PN: "皮特凯恩群岛",
    PR: "波多黎各",
    PS: "巴勒斯坦领土",
    "PS-alt-short": "巴勒斯坦",
    PT: "葡萄牙",
    PW: "帕劳",
    PY: "巴拉圭",
    QA: "卡塔尔",
    QO: "大洋洲边远群岛",
    RE: "留尼汪",
    RO: "罗马尼亚",
    RS: "塞尔维亚",
    RU: "俄罗斯",
    RW: "卢旺达",
    SA: "沙特阿拉伯",
    SB: "所罗门群岛",
    SC: "塞舌尔",
    SD: "苏丹",
    SE: "瑞典",
    SG: "新加坡",
    SH: "圣赫勒拿",
    SI: "斯洛文尼亚",
    SJ: "斯瓦尔巴和扬马延",
    SK: "斯洛伐克",
    SL: "塞拉利昂",
    SM: "圣马力诺",
    SN: "塞内加尔",
    SO: "索马里",
    SR: "苏里南",
    SS: "南苏丹",
    ST: "圣多美和普林西比",
    SV: "萨尔瓦多",
    SX: "荷属圣马丁",
    SY: "叙利亚",
    SZ: "斯威士兰",
    TA: "特里斯坦-达库尼亚群岛",
    TC: "特克斯和凯科斯群岛",
    TD: "乍得",
    TF: "法属南部领地",
    TG: "多哥",
    TH: "泰国",
    TJ: "塔吉克斯坦",
    TK: "托克劳",
    TL: "东帝汶",
    TM: "土库曼斯坦",
    TN: "突尼斯",
    TO: "汤加",
    TR: "土耳其",
    TT: "特立尼达和多巴哥",
    TV: "图瓦卢",
    TW: "中国台湾",
    TZ: "坦桑尼亚",
    UA: "乌克兰",
    UG: "乌干达",
    UM: "美国本土外小岛屿",
    UN: "联合国",
    US: "美国",
    UY: "乌拉圭",
    UZ: "乌兹别克斯坦",
    VA: "梵蒂冈",
    VC: "圣文森特和格林纳丁斯",
    VE: "委内瑞拉",
    VG: "英属维尔京群岛",
    VI: "美属维尔京群岛",
    VN: "越南",
    VU: "瓦努阿图",
    WF: "瓦利斯和富图纳",
    WS: "萨摩亚",
    XA: "伪地区",
    XB: "伪双向语言地区",
    XK: "科索沃",
    YE: "也门",
    YT: "马约特",
    ZA: "南非",
    ZM: "赞比亚",
    ZW: "津巴布韦",
    ZZ: "未知地区",
  },
};
export const languageENMap = {
  languages: {
    aa: "Afar",
    ab: "Abkhazian",
    ace: "Acehnese",
    ach: "Acoli",
    ada: "Adangme",
    ady: "Adyghe",
    ae: "Avestan",
    aeb: "Tunisian Arabic",
    af: "Afrikaans",
    afh: "Afrihili",
    agq: "Aghem",
    ain: "Ainu",
    ak: "Akan",
    akk: "Akkadian",
    akz: "Alabama",
    ale: "Aleut",
    aln: "Gheg Albanian",
    alt: "Southern Altai",
    am: "Amharic",
    an: "Aragonese",
    ang: "Old English",
    ann: "Obolo",
    anp: "Angika",
    ar: "Arabic",
    "ar-001": "Modern Standard Arabic",
    arc: "Aramaic",
    arn: "Mapuche",
    aro: "Araona",
    arp: "Arapaho",
    arq: "Algerian Arabic",
    ars: "Najdi Arabic",
    "ars-alt-menu": "Arabic, Najdi",
    arw: "Arawak",
    ary: "Moroccan Arabic",
    arz: "Egyptian Arabic",
    as: "Assamese",
    asa: "Asu",
    ase: "American Sign Language",
    ast: "Asturian",
    atj: "Atikamekw",
    av: "Avaric",
    avk: "Kotava",
    awa: "Awadhi",
    ay: "Aymara",
    az: "Azerbaijani",
    "az-alt-short": "Azeri",
    ba: "Bashkir",
    bal: "Baluchi",
    ban: "Balinese",
    bar: "Bavarian",
    bas: "Basaa",
    bax: "Bamun",
    bbc: "Batak Toba",
    bbj: "Ghomala",
    be: "Belarusian",
    bej: "Beja",
    bem: "Bemba",
    bew: "Betawi",
    bez: "Bena",
    bfd: "Bafut",
    bfq: "Badaga",
    bg: "Bulgarian",
    bgc: "Haryanvi",
    bgn: "Western Balochi",
    bho: "Bhojpuri",
    bi: "Bislama",
    bik: "Bikol",
    bin: "Bini",
    bjn: "Banjar",
    bkm: "Kom",
    bla: "Siksiká",
    blo: "Anii",
    blt: "Tai Dam",
    bm: "Bambara",
    bn: "Bangla",
    bo: "Tibetan",
    bpy: "Bishnupriya",
    bqi: "Bakhtiari",
    br: "Breton",
    bra: "Braj",
    brh: "Brahui",
    brx: "Bodo",
    bs: "Bosnian",
    bss: "Akoose",
    bua: "Buriat",
    bug: "Buginese",
    bum: "Bulu",
    byn: "Blin",
    byv: "Medumba",
    ca: "Catalan",
    cad: "Caddo",
    car: "Carib",
    cay: "Cayuga",
    cch: "Atsam",
    ccp: "Chakma",
    ce: "Chechen",
    ceb: "Cebuano",
    cgg: "Chiga",
    ch: "Chamorro",
    chb: "Chibcha",
    chg: "Chagatai",
    chk: "Chuukese",
    chm: "Mari",
    chn: "Chinook Jargon",
    cho: "Choctaw",
    chp: "Chipewyan",
    chr: "Cherokee",
    chy: "Cheyenne",
    cic: "Chickasaw",
    ckb: "Central Kurdish",
    "ckb-alt-menu": "Kurdish, Central",
    "ckb-alt-variant": "Kurdish, Sorani",
    clc: "Chilcotin",
    co: "Corsican",
    cop: "Coptic",
    cps: "Capiznon",
    cr: "Cree",
    "cr-alt-long": "Woods Cree",
    crg: "Michif",
    crh: "Crimean Tatar",
    crj: "Southern East Cree",
    crk: "Plains Cree",
    crl: "Northern East Cree",
    crm: "Moose Cree",
    crr: "Carolina Algonquian",
    crs: "Seselwa Creole French",
    cs: "Czech",
    csb: "Kashubian",
    csw: "Swampy Cree",
    cu: "Church Slavic",
    cv: "Chuvash",
    cy: "Welsh",
    da: "Danish",
    dak: "Dakota",
    dar: "Dargwa",
    dav: "Taita",
    de: "German",
    "de-AT": "Austrian German",
    "de-CH": "Swiss High German",
    del: "Delaware",
    den: "Slave",
    dgr: "Dogrib",
    din: "Dinka",
    dje: "Zarma",
    doi: "Dogri",
    dsb: "Lower Sorbian",
    dtp: "Central Dusun",
    dua: "Duala",
    dum: "Middle Dutch",
    dv: "Divehi",
    dyo: "Jola-Fonyi",
    dyu: "Dyula",
    dz: "Dzongkha",
    dzg: "Dazaga",
    ebu: "Embu",
    ee: "Ewe",
    efi: "Efik",
    egl: "Emilian",
    egy: "Ancient Egyptian",
    eka: "Ekajuk",
    el: "Greek",
    elx: "Elamite",
    en: "English",
    "en-AU": "Australian English",
    "en-CA": "Canadian English",
    "en-GB": "British English",
    "en-GB-alt-short": "UK English",
    "en-US": "American English",
    "en-US-alt-short": "US English",
    enm: "Middle English",
    eo: "Esperanto",
    es: "Spanish",
    "es-419": "Latin American Spanish",
    "es-ES": "European Spanish",
    "es-MX": "Mexican Spanish",
    esu: "Central Yupik",
    et: "Estonian",
    eu: "Basque",
    ewo: "Ewondo",
    ext: "Extremaduran",
    fa: "Persian",
    "fa-AF": "Dari",
    fan: "Fang",
    fat: "Fanti",
    ff: "Fula",
    fi: "Finnish",
    fil: "Filipino",
    fit: "Tornedalen Finnish",
    fj: "Fijian",
    fo: "Faroese",
    fon: "Fon",
    fr: "French",
    "fr-CA": "Canadian French",
    "fr-CH": "Swiss French",
    frc: "Cajun French",
    frm: "Middle French",
    fro: "Old French",
    frp: "Arpitan",
    frr: "Northern Frisian",
    frs: "Eastern Frisian",
    fur: "Friulian",
    fy: "Western Frisian",
    ga: "Irish",
    gaa: "Ga",
    gag: "Gagauz",
    gan: "Gan Chinese",
    gay: "Gayo",
    gba: "Gbaya",
    gbz: "Zoroastrian Dari",
    gd: "Scottish Gaelic",
    gez: "Geez",
    gil: "Gilbertese",
    gl: "Galician",
    glk: "Gilaki",
    gmh: "Middle High German",
    gn: "Guarani",
    goh: "Old High German",
    gon: "Gondi",
    gor: "Gorontalo",
    got: "Gothic",
    grb: "Grebo",
    grc: "Ancient Greek",
    gsw: "Swiss German",
    gu: "Gujarati",
    guc: "Wayuu",
    gur: "Frafra",
    guz: "Gusii",
    gv: "Manx",
    gwi: "Gwichʼin",
    ha: "Hausa",
    hai: "Haida",
    hak: "Hakka Chinese",
    haw: "Hawaiian",
    hax: "Southern Haida",
    he: "Hebrew",
    hi: "Hindi",
    "hi-Latn": "Hindi (Latin)",
    "hi-Latn-alt-variant": "Hinglish",
    hif: "Fiji Hindi",
    hil: "Hiligaynon",
    hit: "Hittite",
    hmn: "Hmong",
    hnj: "Hmong Njua",
    ho: "Hiri Motu",
    hr: "Croatian",
    hsb: "Upper Sorbian",
    hsn: "Xiang Chinese",
    ht: "Haitian Creole",
    hu: "Hungarian",
    hup: "Hupa",
    hur: "Halkomelem",
    hy: "Armenian",
    hz: "Herero",
    ia: "Interlingua",
    iba: "Iban",
    ibb: "Ibibio",
    id: "Indonesian",
    ie: "Interlingue",
    ig: "Igbo",
    ii: "Sichuan Yi",
    ik: "Inupiaq",
    ikt: "Western Canadian Inuktitut",
    ilo: "Iloko",
    inh: "Ingush",
    io: "Ido",
    is: "Icelandic",
    it: "Italian",
    iu: "Inuktitut",
    izh: "Ingrian",
    ja: "Japanese",
    jam: "Jamaican Creole English",
    jbo: "Lojban",
    jgo: "Ngomba",
    jmc: "Machame",
    jpr: "Judeo-Persian",
    jrb: "Judeo-Arabic",
    jut: "Jutish",
    jv: "Javanese",
    ka: "Georgian",
    kaa: "Kara-Kalpak",
    kab: "Kabyle",
    kac: "Kachin",
    kaj: "Jju",
    kam: "Kamba",
    kaw: "Kawi",
    kbd: "Kabardian",
    kbl: "Kanembu",
    kcg: "Tyap",
    kde: "Makonde",
    kea: "Kabuverdianu",
    ken: "Kenyang",
    kfo: "Koro",
    kg: "Kongo",
    kgp: "Kaingang",
    kha: "Khasi",
    kho: "Khotanese",
    khq: "Koyra Chiini",
    khw: "Khowar",
    ki: "Kikuyu",
    kiu: "Kirmanjki",
    kj: "Kuanyama",
    kk: "Kazakh",
    kkj: "Kako",
    kl: "Kalaallisut",
    kln: "Kalenjin",
    km: "Khmer",
    kmb: "Kimbundu",
    kn: "Kannada",
    ko: "Korean",
    koi: "Komi-Permyak",
    kok: "Konkani",
    kos: "Kosraean",
    kpe: "Kpelle",
    kr: "Kanuri",
    krc: "Karachay-Balkar",
    kri: "Krio",
    krj: "Kinaray-a",
    krl: "Karelian",
    kru: "Kurukh",
    ks: "Kashmiri",
    ksb: "Shambala",
    ksf: "Bafia",
    ksh: "Colognian",
    ku: "Kurdish",
    kum: "Kumyk",
    kut: "Kutenai",
    kv: "Komi",
    kw: "Cornish",
    kwk: "Kwakʼwala",
    kxv: "Kuvi",
    ky: "Kyrgyz",
    "ky-alt-variant": "Kirghiz",
    la: "Latin",
    lad: "Ladino",
    lag: "Langi",
    lah: "Western Panjabi",
    lam: "Lamba",
    lb: "Luxembourgish",
    lez: "Lezghian",
    lfn: "Lingua Franca Nova",
    lg: "Ganda",
    li: "Limburgish",
    lij: "Ligurian",
    lil: "Lillooet",
    liv: "Livonian",
    lkt: "Lakota",
    lmo: "Lombard",
    ln: "Lingala",
    lo: "Lao",
    lol: "Mongo",
    lou: "Louisiana Creole",
    loz: "Lozi",
    lrc: "Northern Luri",
    lsm: "Saamia",
    lt: "Lithuanian",
    ltg: "Latgalian",
    lu: "Luba-Katanga",
    lua: "Luba-Lulua",
    lui: "Luiseno",
    lun: "Lunda",
    luo: "Luo",
    lus: "Mizo",
    luy: "Luyia",
    lv: "Latvian",
    lzh: "Literary Chinese",
    lzz: "Laz",
    mad: "Madurese",
    maf: "Mafa",
    mag: "Magahi",
    mai: "Maithili",
    mak: "Makasar",
    man: "Mandingo",
    mas: "Masai",
    mde: "Maba",
    mdf: "Moksha",
    mdr: "Mandar",
    men: "Mende",
    mer: "Meru",
    mfe: "Morisyen",
    mg: "Malagasy",
    mga: "Middle Irish",
    mgh: "Makhuwa-Meetto",
    mgo: "Metaʼ",
    mh: "Marshallese",
    mi: "Māori",
    mic: "Mi'kmaw",
    min: "Minangkabau",
    mk: "Macedonian",
    ml: "Malayalam",
    mn: "Mongolian",
    mnc: "Manchu",
    mni: "Manipuri",
    moe: "Innu-aimun",
    moh: "Mohawk",
    mos: "Mossi",
    mr: "Marathi",
    mrj: "Western Mari",
    ms: "Malay",
    mt: "Maltese",
    mua: "Mundang",
    mul: "Multiple languages",
    mus: "Muscogee",
    "mus-alt-official": "Mvskoke",
    mwl: "Mirandese",
    mwr: "Marwari",
    mwv: "Mentawai",
    my: "Burmese",
    "my-alt-variant": "Myanmar Language",
    mye: "Myene",
    myv: "Erzya",
    mzn: "Mazanderani",
    na: "Nauru",
    nan: "Min Nan Chinese",
    nap: "Neapolitan",
    naq: "Nama",
    nb: "Norwegian Bokmål",
    nd: "North Ndebele",
    nds: "Low German",
    "nds-NL": "Low Saxon",
    ne: "Nepali",
    new: "Newari",
    ng: "Ndonga",
    nia: "Nias",
    niu: "Niuean",
    njo: "Ao Naga",
    nl: "Dutch",
    "nl-BE": "Flemish",
    nmg: "Kwasio",
    nn: "Norwegian Nynorsk",
    nnh: "Ngiemboon",
    no: "Norwegian",
    nog: "Nogai",
    non: "Old Norse",
    nov: "Novial",
    nqo: "N’Ko",
    nr: "South Ndebele",
    nso: "Northern Sotho",
    nus: "Nuer",
    nv: "Navajo",
    nwc: "Classical Newari",
    ny: "Nyanja",
    nym: "Nyamwezi",
    nyn: "Nyankole",
    nyo: "Nyoro",
    nzi: "Nzima",
    oc: "Occitan",
    oj: "Ojibwa",
    ojb: "Northwestern Ojibwa",
    ojc: "Central Ojibwa",
    ojs: "Oji-Cree",
    ojw: "Western Ojibwa",
    oka: "Okanagan",
    om: "Oromo",
    or: "Odia",
    os: "Ossetic",
    osa: "Osage",
    ota: "Ottoman Turkish",
    pa: "Punjabi",
    pag: "Pangasinan",
    pal: "Pahlavi",
    pam: "Pampanga",
    pap: "Papiamento",
    pau: "Palauan",
    pcd: "Picard",
    pcm: "Nigerian Pidgin",
    pdc: "Pennsylvania German",
    pdt: "Plautdietsch",
    peo: "Old Persian",
    pfl: "Palatine German",
    phn: "Phoenician",
    pi: "Pali",
    pis: "Pijin",
    pl: "Polish",
    pms: "Piedmontese",
    pnt: "Pontic",
    pon: "Pohnpeian",
    pqm: "Maliseet-Passamaquoddy",
    prg: "Prussian",
    pro: "Old Provençal",
    ps: "Pashto",
    "ps-alt-variant": "Pushto",
    pt: "Portuguese",
    "pt-BR": "Brazilian Portuguese",
    "pt-PT": "European Portuguese",
    qu: "Quechua",
    quc: "Kʼicheʼ",
    qug: "Chimborazo Highland Quichua",
    raj: "Rajasthani",
    rap: "Rapanui",
    rar: "Rarotongan",
    rgn: "Romagnol",
    rhg: "Rohingya",
    rif: "Riffian",
    rm: "Romansh",
    rn: "Rundi",
    ro: "Romanian",
    "ro-MD": "Moldavian",
    rof: "Rombo",
    rom: "Romany",
    rtm: "Rotuman",
    ru: "Russian",
    rue: "Rusyn",
    rug: "Roviana",
    rup: "Aromanian",
    rw: "Kinyarwanda",
    rwk: "Rwa",
    sa: "Sanskrit",
    sad: "Sandawe",
    sah: "Yakut",
    sam: "Samaritan Aramaic",
    saq: "Samburu",
    sas: "Sasak",
    sat: "Santali",
    saz: "Saurashtra",
    sba: "Ngambay",
    sbp: "Sangu",
    sc: "Sardinian",
    scn: "Sicilian",
    sco: "Scots",
    sd: "Sindhi",
    sdc: "Sassarese Sardinian",
    sdh: "Southern Kurdish",
    se: "Northern Sami",
    "se-alt-menu": "Sami, Northern",
    see: "Seneca",
    seh: "Sena",
    sei: "Seri",
    sel: "Selkup",
    ses: "Koyraboro Senni",
    sg: "Sango",
    sga: "Old Irish",
    sgs: "Samogitian",
    sh: "Serbo-Croatian",
    shi: "Tachelhit",
    shn: "Shan",
    shu: "Chadian Arabic",
    si: "Sinhala",
    sid: "Sidamo",
    sk: "Slovak",
    sl: "Slovenian",
    slh: "Southern Lushootseed",
    sli: "Lower Silesian",
    sly: "Selayar",
    sm: "Samoan",
    sma: "Southern Sami",
    "sma-alt-menu": "Sami, Southern",
    smj: "Lule Sami",
    "smj-alt-menu": "Sami, Lule",
    smn: "Inari Sami",
    "smn-alt-menu": "Sami, Inari",
    sms: "Skolt Sami",
    "sms-alt-menu": "Sami, Skolt",
    sn: "Shona",
    snk: "Soninke",
    so: "Somali",
    sog: "Sogdien",
    sq: "Albanian",
    sr: "Serbian",
    "sr-ME": "Montenegrin",
    srn: "Sranan Tongo",
    srr: "Serer",
    ss: "Swati",
    ssy: "Saho",
    st: "Southern Sotho",
    stq: "Saterland Frisian",
    str: "Straits Salish",
    su: "Sundanese",
    suk: "Sukuma",
    sus: "Susu",
    sux: "Sumerian",
    sv: "Swedish",
    sw: "Swahili",
    "sw-CD": "Congo Swahili",
    swb: "Comorian",
    syc: "Classical Syriac",
    syr: "Syriac",
    szl: "Silesian",
    ta: "Tamil",
    tce: "Southern Tutchone",
    tcy: "Tulu",
    te: "Telugu",
    tem: "Timne",
    teo: "Teso",
    ter: "Tereno",
    tet: "Tetum",
    tg: "Tajik",
    tgx: "Tagish",
    th: "Thai",
    tht: "Tahltan",
    ti: "Tigrinya",
    tig: "Tigre",
    tiv: "Tiv",
    tk: "Turkmen",
    tkl: "Tokelau",
    tkr: "Tsakhur",
    tl: "Tagalog",
    tlh: "Klingon",
    tli: "Tlingit",
    tly: "Talysh",
    tmh: "Tamashek",
    tn: "Tswana",
    to: "Tongan",
    tog: "Nyasa Tonga",
    tok: "Toki Pona",
    tpi: "Tok Pisin",
    tr: "Turkish",
    tru: "Turoyo",
    trv: "Taroko",
    trw: "Torwali",
    ts: "Tsonga",
    tsd: "Tsakonian",
    tsi: "Tsimshian",
    tt: "Tatar",
    ttm: "Northern Tutchone",
    ttt: "Muslim Tat",
    tum: "Tumbuka",
    tvl: "Tuvalu",
    tw: "Twi",
    twq: "Tasawaq",
    ty: "Tahitian",
    tyv: "Tuvinian",
    tzm: "Central Atlas Tamazight",
    udm: "Udmurt",
    ug: "Uyghur",
    "ug-alt-variant": "Uighur",
    uga: "Ugaritic",
    uk: "Ukrainian",
    umb: "Umbundu",
    und: "Unknown language",
    ur: "Urdu",
    uz: "Uzbek",
    vai: "Vai",
    ve: "Venda",
    vec: "Venetian",
    vep: "Veps",
    vi: "Vietnamese",
    vls: "West Flemish",
    vmf: "Main-Franconian",
    vmw: "Makhuwa",
    vo: "Volapük",
    vot: "Votic",
    vro: "Võro",
    vun: "Vunjo",
    wa: "Walloon",
    wae: "Walser",
    wal: "Wolaytta",
    war: "Waray",
    was: "Washo",
    wbp: "Warlpiri",
    wo: "Wolof",
    wuu: "Wu Chinese",
    xal: "Kalmyk",
    xh: "Xhosa",
    xmf: "Mingrelian",
    xnr: "Kangri",
    xog: "Soga",
    yao: "Yao",
    yap: "Yapese",
    yav: "Yangben",
    ybb: "Yemba",
    yi: "Yiddish",
    yo: "Yoruba",
    yrl: "Nheengatu",
    yue: "Cantonese",
    "yue-alt-menu": "Chinese, Cantonese",
    za: "Zhuang",
    zap: "Zapotec",
    zbl: "Blissymbols",
    zea: "Zeelandic",
    zen: "Zenaga",
    zgh: "Standard Moroccan Tamazight",
    zh: "Chinese",
    "zh-alt-long": "Mandarin Chinese",
    "zh-alt-menu": "Chinese, Mandarin",
    "zh-Hans": "Simplified Chinese",
    "zh-Hans-alt-long": "Simplified Mandarin Chinese",
    "zh-Hant": "Traditional Chinese",
    "zh-Hant-alt-long": "Traditional Mandarin Chinese",
    zu: "Zulu",
    zun: "Zuni",
    zxx: "No linguistic content",
    zza: "Zaza",
  },
  territories: {
    "001": "world",
    "002": "Africa",
    "003": "North America",
    "005": "South America",
    "009": "Oceania",
    "011": "Western Africa",
    "013": "Central America",
    "014": "Eastern Africa",
    "015": "Northern Africa",
    "017": "Middle Africa",
    "018": "Southern Africa",
    "019": "Americas",
    "021": "Northern America",
    "029": "Caribbean",
    "030": "Eastern Asia",
    "034": "Southern Asia",
    "035": "Southeast Asia",
    "039": "Southern Europe",
    "053": "Australasia",
    "054": "Melanesia",
    "057": "Micronesian Region",
    "061": "Polynesia",
    "142": "Asia",
    "143": "Central Asia",
    "145": "Western Asia",
    "150": "Europe",
    "151": "Eastern Europe",
    "154": "Northern Europe",
    "155": "Western Europe",
    "202": "Sub-Saharan Africa",
    "419": "Latin America",
    AC: "Ascension Island",
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua & Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "Åland Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia & Herzegovina",
    "BA-alt-short": "Bosnia",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "St. Barthélemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivia",
    BQ: "Caribbean Netherlands",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos (Keeling) Islands",
    "CC-alt-short": "Cocos Islands",
    CD: "Congo - Kinshasa",
    "CD-alt-variant": "Congo (DRC)",
    CF: "Central African Republic",
    CG: "Congo - Brazzaville",
    "CG-alt-variant": "Congo (Republic)",
    CH: "Switzerland",
    CI: "Côte d’Ivoire",
    "CI-alt-variant": "Ivory Coast",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CP: "Clipperton Island",
    CQ: "Sark",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    "CV-alt-variant": "Cabo Verde",
    CW: "Curaçao",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czechia",
    "CZ-alt-variant": "Czech Republic",
    DE: "Germany",
    DG: "Diego Garcia",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EA: "Ceuta & Melilla",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    EU: "European Union",
    EZ: "Eurozone",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    "FK-alt-variant": "Falkland Islands (Islas Malvinas)",
    FM: "Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    "GB-alt-short": "UK",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia & South Sandwich Islands",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong SAR China",
    "HK-alt-short": "Hong Kong",
    HM: "Heard & McDonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    IC: "Canary Islands",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    "IO-alt-chagos": "Chagos Archipelago",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "St. Kitts & Nevis",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "St. Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "St. Martin",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "North Macedonia",
    ML: "Mali",
    MM: "Myanmar (Burma)",
    "MM-alt-short": "Myanmar",
    MN: "Mongolia",
    MO: "Macao SAR China",
    "MO-alt-short": "Macao",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    "NZ-alt-variant": "Aotearoa New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "St. Pierre & Miquelon",
    PN: "Pitcairn Islands",
    "PN-alt-short": "Pitcairn",
    PR: "Puerto Rico",
    PS: "Palestinian Territories",
    "PS-alt-short": "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    QO: "Outlying Oceania",
    RE: "Réunion",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "St. Helena",
    SI: "Slovenia",
    SJ: "Svalbard & Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "São Tomé & Príncipe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syria",
    SZ: "Eswatini",
    "SZ-alt-variant": "Swaziland",
    TA: "Tristan da Cunha",
    TC: "Turks & Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    "TL-alt-variant": "East Timor",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Türkiye",
    "TR-alt-variant": "Turkey",
    TT: "Trinidad & Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "U.S. Outlying Islands",
    UN: "United Nations",
    "UN-alt-short": "UN",
    US: "United States",
    "US-alt-short": "US",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Vatican City",
    VC: "St. Vincent & Grenadines",
    VE: "Venezuela",
    VG: "British Virgin Islands",
    VI: "U.S. Virgin Islands",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis & Futuna",
    WS: "Samoa",
    XA: "Pseudo-Accents",
    XB: "Pseudo-Bidi",
    XK: "Kosovo",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    ZZ: "Unknown Region",
  },
};
export const officialVoiceList = [
  {
    name: "af_alloy",
    gender: "female",
    displayName: "Alloy",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_aoede",
    gender: "female",
    displayName: "Aoede",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_bella",
    gender: "female",
    displayName: "Bella",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_heart",
    gender: "female",
    displayName: "Heart",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_jessica",
    gender: "female",
    displayName: "Jessica",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_kore",
    gender: "female",
    displayName: "Kore",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_nicole",
    gender: "female",
    displayName: "Nicole",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_nova",
    gender: "female",
    displayName: "Nova",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_river",
    gender: "female",
    displayName: "River",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_sarah",
    gender: "female",
    displayName: "Sarah",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "af_sky",
    gender: "female",
    displayName: "Sky",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_adam",
    gender: "male",
    displayName: "Adam",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_echo",
    gender: "male",
    displayName: "Echo",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_eric",
    gender: "male",
    displayName: "Eric",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_fenrir",
    gender: "male",
    displayName: "Fenrir",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_liam",
    gender: "male",
    displayName: "Liam",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_michael",
    gender: "male",
    displayName: "Michael",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_onyx",
    gender: "male",
    displayName: "Onyx",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_puck",
    gender: "male",
    displayName: "Puck",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "am_santa",
    gender: "male",
    displayName: "Santa",
    locale: "en-US",
    language: "English (US)",
  },
  {
    name: "bf_alice",
    gender: "female",
    displayName: "Alice",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bf_emma",
    gender: "female",
    displayName: "Emma",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bf_isabella",
    gender: "female",
    displayName: "Isabella",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bf_lily",
    gender: "female",
    displayName: "Lily",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bm_daniel",
    gender: "male",
    displayName: "Daniel",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bm_fable",
    gender: "male",
    displayName: "Fable",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bm_george",
    gender: "male",
    displayName: "George",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "bm_lewis",
    gender: "male",
    displayName: "Lewis",
    locale: "en-GB",
    language: "English (UK)",
  },
  {
    name: "ef_dora",
    gender: "female",
    displayName: "Dora",
    locale: "es-ES",
    language: "Español",
  },
  {
    name: "em_alex",
    gender: "male",
    displayName: "Alex",
    locale: "es-ES",
    language: "Español",
  },
  {
    name: "em_santa",
    gender: "male",
    displayName: "Santa",
    locale: "es-ES",
    language: "Español",
  },
  {
    name: "ff_siwis",
    gender: "female",
    displayName: "Siwis",
    locale: "fr-FR",
    language: "Français",
  },
  {
    name: "hf_alpha",
    gender: "female",
    displayName: "Alpha",
    locale: "hi-IN",
    language: "हिन्दी",
  },
  {
    name: "hf_beta",
    gender: "female",
    displayName: "Beta",
    locale: "hi-IN",
    language: "हिन्दी",
  },
  {
    name: "hm_omega",
    gender: "male",
    displayName: "Omega",
    locale: "hi-IN",
    language: "हिन्दी",
  },
  {
    name: "hm_psi",
    gender: "male",
    displayName: "Psi",
    locale: "hi-IN",
    language: "हिन्दी",
  },
  {
    name: "if_sara",
    gender: "female",
    displayName: "Sara",
    locale: "it-IT",
    language: "Italiano",
  },
  {
    name: "im_nicola",
    gender: "male",
    displayName: "Nicola",
    locale: "it-IT",
    language: "Italiano",
  },
  {
    name: "jf_alpha",
    gender: "female",
    displayName: "Alpha",
    locale: "ja-JP",
    language: "日本語",
  },
  {
    name: "jf_gongitsune",
    gender: "female",
    displayName: "Gongitsune",
    locale: "ja-JP",
    language: "日本語",
  },
  {
    name: "jf_nezumi",
    gender: "female",
    displayName: "Nezumi",
    locale: "ja-JP",
    language: "日本語",
  },
  {
    name: "jf_tebukuro",
    gender: "female",
    displayName: "Tebukuro",
    locale: "ja-JP",
    language: "日本語",
  },
  {
    name: "jm_kumo",
    gender: "male",
    displayName: "Kumo",
    locale: "ja-JP",
    language: "日本語",
  },
  {
    name: "pf_dora",
    gender: "female",
    displayName: "Dora",
    locale: "pt-BR",
    language: "Português (Brasil)",
  },
  {
    name: "pm_alex",
    gender: "male",
    displayName: "Alex",
    locale: "pt-BR",
    language: "Português (Brasil)",
  },
  {
    name: "pm_santa",
    gender: "male",
    displayName: "Santa",
    locale: "pt-BR",
    language: "Português (Brasil)",
  },
  {
    name: "zf_xiaoxiao",
    gender: "female",
    displayName: "Xiaoxiao",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zf_xiaoyi",
    gender: "female",
    displayName: "Xiaoyi",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zm_yunyang",
    gender: "male",
    displayName: "Yunyang",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zm_yunxia",
    gender: "male",
    displayName: "Yunxia",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zm_yunxi",
    gender: "male",
    displayName: "Yunxi",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zm_yunjian",
    gender: "male",
    displayName: "Yunjian",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zf_xiaoni",
    gender: "female",
    displayName: "Xiaoni",
    locale: "zh-CN",
    language: "中文",
  },
  {
    name: "zf_xiaobei",
    gender: "female",
    displayName: "Xiaobei",
    locale: "zh-CN",
    language: "中文",
  },
];
export const azureTTSVoiceList = [
  {
    name: "af-ZA-AdriNeural",
    gender: "female",
    displayName: "Adri",
    locale: "af-ZA",
  },
  {
    name: "af-ZA-WillemNeural",
    gender: "male",
    displayName: "Willem",
    locale: "af-ZA",
  },
  {
    name: "am-ET-MekdesNeural",
    gender: "female",
    displayName: "መቅደስ",
    locale: "am-ET",
  },
  {
    name: "am-ET-AmehaNeural",
    gender: "male",
    displayName: "አምሀ",
    locale: "am-ET",
  },
  {
    name: "ar-AE-FatimaNeural",
    gender: "female",
    displayName: "فاطمة",
    locale: "ar-AE",
  },
  {
    name: "ar-AE-HamdanNeural",
    gender: "male",
    displayName: "حمدان",
    locale: "ar-AE",
  },
  {
    name: "ar-BH-LailaNeural",
    gender: "female",
    displayName: "ليلى",
    locale: "ar-BH",
  },
  {
    name: "ar-BH-AliNeural",
    gender: "male",
    displayName: "علي",
    locale: "ar-BH",
  },
  {
    name: "ar-DZ-AminaNeural",
    gender: "female",
    displayName: "أمينة",
    locale: "ar-DZ",
  },
  {
    name: "ar-DZ-IsmaelNeural",
    gender: "male",
    displayName: "إسماعيل",
    locale: "ar-DZ",
  },
  {
    name: "ar-EG-SalmaNeural",
    gender: "female",
    displayName: "سلمى",
    locale: "ar-EG",
  },
  {
    name: "ar-EG-ShakirNeural",
    gender: "male",
    displayName: "شاكر",
    locale: "ar-EG",
  },
  {
    name: "ar-IQ-RanaNeural",
    gender: "female",
    displayName: "رنا",
    locale: "ar-IQ",
  },
  {
    name: "ar-IQ-BasselNeural",
    gender: "male",
    displayName: "باسل",
    locale: "ar-IQ",
  },
  {
    name: "ar-JO-SanaNeural",
    gender: "female",
    displayName: "سناء",
    locale: "ar-JO",
  },
  {
    name: "ar-JO-TaimNeural",
    gender: "male",
    displayName: "تيم",
    locale: "ar-JO",
  },
  {
    name: "ar-KW-NouraNeural",
    gender: "female",
    displayName: "نورا",
    locale: "ar-KW",
  },
  {
    name: "ar-KW-FahedNeural",
    gender: "male",
    displayName: "فهد",
    locale: "ar-KW",
  },
  {
    name: "ar-LB-LaylaNeural",
    gender: "female",
    displayName: "ليلى",
    locale: "ar-LB",
  },
  {
    name: "ar-LB-RamiNeural",
    gender: "male",
    displayName: "رامي",
    locale: "ar-LB",
  },
  {
    name: "ar-LY-ImanNeural",
    gender: "female",
    displayName: "إيمان",
    locale: "ar-LY",
  },
  {
    name: "ar-LY-OmarNeural",
    gender: "male",
    displayName: "أحمد",
    locale: "ar-LY",
  },
  {
    name: "ar-MA-MounaNeural",
    gender: "female",
    displayName: "منى",
    locale: "ar-MA",
  },
  {
    name: "ar-MA-JamalNeural",
    gender: "male",
    displayName: "جمال",
    locale: "ar-MA",
  },
  {
    name: "ar-OM-AyshaNeural",
    gender: "female",
    displayName: "عائشة",
    locale: "ar-OM",
  },
  {
    name: "ar-OM-AbdullahNeural",
    gender: "male",
    displayName: "عبدالله",
    locale: "ar-OM",
  },
  {
    name: "ar-QA-AmalNeural",
    gender: "female",
    displayName: "أمل",
    locale: "ar-QA",
  },
  {
    name: "ar-QA-MoazNeural",
    gender: "male",
    displayName: "معاذ",
    locale: "ar-QA",
  },
  {
    name: "ar-SA-ZariyahNeural",
    gender: "female",
    displayName: "زارية",
    locale: "ar-SA",
  },
  {
    name: "ar-SA-HamedNeural",
    gender: "male",
    displayName: "حامد",
    locale: "ar-SA",
  },
  {
    name: "ar-SY-AmanyNeural",
    gender: "female",
    displayName: "أماني",
    locale: "ar-SY",
  },
  {
    name: "ar-SY-LaithNeural",
    gender: "male",
    displayName: "ليث",
    locale: "ar-SY",
  },
  {
    name: "ar-TN-ReemNeural",
    gender: "female",
    displayName: "ريم",
    locale: "ar-TN",
  },
  {
    name: "ar-TN-HediNeural",
    gender: "male",
    displayName: "هادي",
    locale: "ar-TN",
  },
  {
    name: "ar-YE-MaryamNeural",
    gender: "female",
    displayName: "مريم",
    locale: "ar-YE",
  },
  {
    name: "ar-YE-SalehNeural",
    gender: "male",
    displayName: "صالح",
    locale: "ar-YE",
  },
  {
    name: "as-IN-YashicaNeural",
    gender: "female",
    displayName: "যাশিকা",
    locale: "as-IN",
  },
  {
    name: "as-IN-PriyomNeural",
    gender: "male",
    displayName: "প্ৰিয়ম",
    locale: "as-IN",
  },
  {
    name: "az-AZ-BanuNeural",
    gender: "female",
    displayName: "Banu",
    locale: "az-AZ",
  },
  {
    name: "az-AZ-BabekNeural",
    gender: "male",
    displayName: "Babək",
    locale: "az-AZ",
  },
  {
    name: "bg-BG-KalinaNeural",
    gender: "female",
    displayName: "Калина",
    locale: "bg-BG",
  },
  {
    name: "bg-BG-BorislavNeural",
    gender: "male",
    displayName: "Борислав",
    locale: "bg-BG",
  },
  {
    name: "bn-BD-NabanitaNeural",
    gender: "female",
    displayName: "নবনীতা",
    locale: "bn-BD",
  },
  {
    name: "bn-BD-PradeepNeural",
    gender: "male",
    displayName: "প্রদ্বীপ",
    locale: "bn-BD",
  },
  {
    name: "bn-IN-TanishaaNeural",
    gender: "female",
    displayName: "তানিশা",
    locale: "bn-IN",
  },
  {
    name: "bn-IN-BashkarNeural",
    gender: "male",
    displayName: "ভাস্কর",
    locale: "bn-IN",
  },
  {
    name: "bs-BA-VesnaNeural",
    gender: "female",
    displayName: "Vesna",
    locale: "bs-BA",
  },
  {
    name: "bs-BA-GoranNeural",
    gender: "male",
    displayName: "Goran",
    locale: "bs-BA",
  },
  {
    name: "ca-ES-JoanaNeural",
    gender: "female",
    displayName: "Joana",
    locale: "ca-ES",
  },
  {
    name: "ca-ES-EnricNeural",
    gender: "male",
    displayName: "Enric",
    locale: "ca-ES",
  },
  {
    name: "ca-ES-AlbaNeural",
    gender: "female",
    displayName: "Alba",
    locale: "ca-ES",
  },
  {
    name: "cs-CZ-VlastaNeural",
    gender: "female",
    displayName: "Vlasta",
    locale: "cs-CZ",
  },
  {
    name: "cs-CZ-AntoninNeural",
    gender: "male",
    displayName: "Antonín",
    locale: "cs-CZ",
  },
  {
    name: "cy-GB-NiaNeural",
    gender: "female",
    displayName: "Nia",
    locale: "cy-GB",
  },
  {
    name: "cy-GB-AledNeural",
    gender: "male",
    displayName: "Aled",
    locale: "cy-GB",
  },
  {
    name: "da-DK-ChristelNeural",
    gender: "female",
    displayName: "Christel",
    locale: "da-DK",
  },
  {
    name: "da-DK-JeppeNeural",
    gender: "male",
    displayName: "Jeppe",
    locale: "da-DK",
  },
  {
    name: "de-AT-IngridNeural",
    gender: "female",
    displayName: "Ingrid",
    locale: "de-AT",
  },
  {
    name: "de-AT-JonasNeural",
    gender: "male",
    displayName: "Jonas",
    locale: "de-AT",
  },
  {
    name: "de-CH-LeniNeural",
    gender: "female",
    displayName: "Leni",
    locale: "de-CH",
  },
  {
    name: "de-CH-JanNeural",
    gender: "male",
    displayName: "Jan",
    locale: "de-CH",
  },
  {
    name: "de-DE-KatjaNeural",
    gender: "female",
    displayName: "Katja",
    locale: "de-DE",
  },
  {
    name: "de-DE-ConradNeural",
    gender: "male",
    displayName: "Conrad",
    locale: "de-DE",
  },
  {
    name: "de-DE-SeraphinaMultilingualNeural",
    gender: "female",
    displayName: "Seraphine Mehrsprachig",
    locale: "de-DE",
  },
  {
    name: "de-DE-FlorianMultilingualNeural",
    gender: "male",
    displayName: "Florian Mehrsprachig",
    locale: "de-DE",
  },
  {
    name: "de-DE-AmalaNeural",
    gender: "female",
    displayName: "Amala",
    locale: "de-DE",
  },
  {
    name: "de-DE-BerndNeural",
    gender: "male",
    displayName: "Bernd",
    locale: "de-DE",
  },
  {
    name: "de-DE-ChristophNeural",
    gender: "male",
    displayName: "Christoph",
    locale: "de-DE",
  },
  {
    name: "de-DE-ElkeNeural",
    gender: "female",
    displayName: "Elke",
    locale: "de-DE",
  },
  {
    name: "de-DE-GiselaNeural",
    gender: "female",
    displayName: "Gisela",
    locale: "de-DE",
  },
  {
    name: "de-DE-KasperNeural",
    gender: "male",
    displayName: "Kasper",
    locale: "de-DE",
  },
  {
    name: "de-DE-KillianNeural",
    gender: "male",
    displayName: "Killian",
    locale: "de-DE",
  },
  {
    name: "de-DE-KlarissaNeural",
    gender: "female",
    displayName: "Klarissa",
    locale: "de-DE",
  },
  {
    name: "de-DE-KlausNeural",
    gender: "male",
    displayName: "Klaus",
    locale: "de-DE",
  },
  {
    name: "de-DE-LouisaNeural",
    gender: "female",
    displayName: "Louisa",
    locale: "de-DE",
  },
  {
    name: "de-DE-MajaNeural",
    gender: "female",
    displayName: "Maja",
    locale: "de-DE",
  },
  {
    name: "de-DE-RalfNeural",
    gender: "male",
    displayName: "Ralf",
    locale: "de-DE",
  },
  {
    name: "de-DE-TanjaNeural",
    gender: "female",
    displayName: "Tanja",
    locale: "de-DE",
  },
  {
    name: "el-GR-AthinaNeural",
    gender: "female",
    displayName: "Αθηνά",
    locale: "el-GR",
  },
  {
    name: "el-GR-NestorasNeural",
    gender: "male",
    displayName: "Νέστορας",
    locale: "el-GR",
  },
  {
    name: "en-AU-NatashaNeural",
    gender: "female",
    displayName: "Natasha",
    locale: "en-AU",
  },
  {
    name: "en-AU-WilliamNeural",
    gender: "male",
    displayName: "William",
    locale: "en-AU",
  },
  {
    name: "en-AU-WilliamMultilingualNeural",
    gender: "male",
    displayName: "William Multilingual",
    locale: "en-AU",
  },
  {
    name: "en-AU-AnnetteNeural",
    gender: "female",
    displayName: "Annette",
    locale: "en-AU",
  },
  {
    name: "en-AU-CarlyNeural",
    gender: "female",
    displayName: "Carly",
    locale: "en-AU",
  },
  {
    name: "en-AU-DarrenNeural",
    gender: "male",
    displayName: "Darren",
    locale: "en-AU",
  },
  {
    name: "en-AU-DuncanNeural",
    gender: "male",
    displayName: "Duncan",
    locale: "en-AU",
  },
  {
    name: "en-AU-ElsieNeural",
    gender: "female",
    displayName: "Elsie",
    locale: "en-AU",
  },
  {
    name: "en-AU-FreyaNeural",
    gender: "female",
    displayName: "Freya",
    locale: "en-AU",
  },
  {
    name: "en-AU-JoanneNeural",
    gender: "female",
    displayName: "Joanne",
    locale: "en-AU",
  },
  {
    name: "en-AU-KenNeural",
    gender: "male",
    displayName: "Ken",
    locale: "en-AU",
  },
  {
    name: "en-AU-KimNeural",
    gender: "female",
    displayName: "Kim",
    locale: "en-AU",
  },
  {
    name: "en-AU-NeilNeural",
    gender: "male",
    displayName: "Neil",
    locale: "en-AU",
  },
  {
    name: "en-AU-TimNeural",
    gender: "male",
    displayName: "Tim",
    locale: "en-AU",
  },
  {
    name: "en-AU-TinaNeural",
    gender: "female",
    displayName: "Tina",
    locale: "en-AU",
  },
  {
    name: "en-CA-ClaraNeural",
    gender: "female",
    displayName: "Clara",
    locale: "en-CA",
  },
  {
    name: "en-CA-LiamNeural",
    gender: "male",
    displayName: "Liam",
    locale: "en-CA",
  },
  {
    name: "en-GB-SoniaNeural",
    gender: "female",
    displayName: "Sonia",
    locale: "en-GB",
  },
  {
    name: "en-GB-RyanNeural",
    gender: "male",
    displayName: "Ryan",
    locale: "en-GB",
  },
  {
    name: "en-GB-LibbyNeural",
    gender: "female",
    displayName: "Libby",
    locale: "en-GB",
  },
  {
    name: "en-GB-AdaMultilingualNeural",
    gender: "female",
    displayName: "Ada Multilingual",
    locale: "en-GB",
  },
  {
    name: "en-GB-OllieMultilingualNeural",
    gender: "male",
    displayName: "Ollie Multilingual",
    locale: "en-GB",
  },
  {
    name: "en-GB-AbbiNeural",
    gender: "female",
    displayName: "Abbi",
    locale: "en-GB",
  },
  {
    name: "en-GB-AlfieNeural",
    gender: "male",
    displayName: "Alfie",
    locale: "en-GB",
  },
  {
    name: "en-GB-BellaNeural",
    gender: "female",
    displayName: "Bella",
    locale: "en-GB",
  },
  {
    name: "en-GB-ElliotNeural",
    gender: "male",
    displayName: "Elliot",
    locale: "en-GB",
  },
  {
    name: "en-GB-EthanNeural",
    gender: "male",
    displayName: "Ethan",
    locale: "en-GB",
  },
  {
    name: "en-GB-HollieNeural",
    gender: "female",
    displayName: "Hollie",
    locale: "en-GB",
  },
  {
    name: "en-GB-MaisieNeural",
    gender: "female",
    displayName: "Maisie",
    locale: "en-GB",
  },
  {
    name: "en-GB-NoahNeural",
    gender: "male",
    displayName: "Noah",
    locale: "en-GB",
  },
  {
    name: "en-GB-OliverNeural",
    gender: "male",
    displayName: "Oliver",
    locale: "en-GB",
  },
  {
    name: "en-GB-OliviaNeural",
    gender: "female",
    displayName: "Olivia",
    locale: "en-GB",
  },
  {
    name: "en-GB-ThomasNeural",
    gender: "male",
    displayName: "Thomas",
    locale: "en-GB",
  },
  {
    name: "en-GB-MiaNeural",
    gender: "female",
    displayName: "Mia",
    locale: "en-GB",
  },
  {
    name: "en-HK-YanNeural",
    gender: "female",
    displayName: "Yan",
    locale: "en-HK",
  },
  {
    name: "en-HK-SamNeural",
    gender: "male",
    displayName: "Sam",
    locale: "en-HK",
  },
  {
    name: "en-IE-EmilyNeural",
    gender: "female",
    displayName: "Emily",
    locale: "en-IE",
  },
  {
    name: "en-IE-ConnorNeural",
    gender: "male",
    displayName: "Connor",
    locale: "en-IE",
  },
  {
    name: "en-IN-AartiIndicNeural",
    gender: "female",
    displayName: "Aarti Indic",
    locale: "en-IN",
  },
  {
    name: "en-IN-ArjunIndicNeural",
    gender: "male",
    displayName: "Arjun Indic",
    locale: "en-IN",
  },
  {
    name: "en-IN-NeerjaIndicNeural",
    gender: "female",
    displayName: "Neerja Indic",
    locale: "en-IN",
  },
  {
    name: "en-IN-PrabhatIndicNeural",
    gender: "male",
    displayName: "Prabhat Indic",
    locale: "en-IN",
  },
  {
    name: "en-IN-AaravNeural",
    gender: "male",
    displayName: "Aarav",
    locale: "en-IN",
  },
  {
    name: "en-IN-AashiNeural",
    gender: "female",
    displayName: "Aashi",
    locale: "en-IN",
  },
  {
    name: "en-IN-AartiNeural",
    gender: "female",
    displayName: "Aarti",
    locale: "en-IN",
  },
  {
    name: "en-IN-ArjunNeural",
    gender: "male",
    displayName: "Arjun",
    locale: "en-IN",
  },
  {
    name: "en-IN-AnanyaNeural",
    gender: "female",
    displayName: "Ananya",
    locale: "en-IN",
  },
  {
    name: "en-IN-KavyaNeural",
    gender: "female",
    displayName: "Kavya",
    locale: "en-IN",
  },
  {
    name: "en-IN-KunalNeural",
    gender: "male",
    displayName: "Kunal",
    locale: "en-IN",
  },
  {
    name: "en-IN-NeerjaNeural",
    gender: "female",
    displayName: "Neerja",
    locale: "en-IN",
  },
  {
    name: "en-IN-PrabhatNeural",
    gender: "male",
    displayName: "Prabhat",
    locale: "en-IN",
  },
  {
    name: "en-IN-RehaanNeural",
    gender: "male",
    displayName: "Rehaan",
    locale: "en-IN",
  },
  {
    name: "en-KE-AsiliaNeural",
    gender: "female",
    displayName: "Asilia",
    locale: "en-KE",
  },
  {
    name: "en-KE-ChilembaNeural",
    gender: "male",
    displayName: "Chilemba",
    locale: "en-KE",
  },
  {
    name: "en-NG-EzinneNeural",
    gender: "female",
    displayName: "Ezinne",
    locale: "en-NG",
  },
  {
    name: "en-NG-AbeoNeural",
    gender: "male",
    displayName: "Abeo",
    locale: "en-NG",
  },
  {
    name: "en-NZ-MollyNeural",
    gender: "female",
    displayName: "Molly",
    locale: "en-NZ",
  },
  {
    name: "en-NZ-MitchellNeural",
    gender: "male",
    displayName: "Mitchell",
    locale: "en-NZ",
  },
  {
    name: "en-PH-RosaNeural",
    gender: "female",
    displayName: "Rosa",
    locale: "en-PH",
  },
  {
    name: "en-PH-JamesNeural",
    gender: "male",
    displayName: "James",
    locale: "en-PH",
  },
  {
    name: "en-SG-LunaNeural",
    gender: "female",
    displayName: "Luna",
    locale: "en-SG",
  },
  {
    name: "en-SG-WayneNeural",
    gender: "male",
    displayName: "Wayne",
    locale: "en-SG",
  },
  {
    name: "en-TZ-ImaniNeural",
    gender: "female",
    displayName: "Imani",
    locale: "en-TZ",
  },
  {
    name: "en-TZ-ElimuNeural",
    gender: "male",
    displayName: "Elimu",
    locale: "en-TZ",
  },
  {
    name: "en-US-AvaMultilingualNeural",
    gender: "female",
    displayName: "Ava Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AndrewMultilingualNeural",
    gender: "male",
    displayName: "Andrew Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AmandaMultilingualNeural",
    gender: "female",
    displayName: "Amanda Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AdamMultilingualNeural",
    gender: "male",
    displayName: "Adam Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-EmmaMultilingualNeural",
    gender: "female",
    displayName: "Emma Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-PhoebeMultilingualNeural",
    gender: "female",
    displayName: "Phoebe Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AlloyTurboMultilingualNeural",
    gender: "male",
    displayName: "Alloy Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-EchoTurboMultilingualNeural",
    gender: "male",
    displayName: "Echo Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-FableTurboMultilingualNeural",
    gender: "female",
    displayName: "Fable Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-OnyxTurboMultilingualNeural",
    gender: "male",
    displayName: "Onyx Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-NovaTurboMultilingualNeural",
    gender: "female",
    displayName: "Nova Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-ShimmerTurboMultilingualNeural",
    gender: "female",
    displayName: "Shimmer Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-BrianMultilingualNeural",
    gender: "male",
    displayName: "Brian Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AvaNeural",
    gender: "female",
    displayName: "Ava",
    locale: "en-US",
  },
  {
    name: "en-US-AndrewNeural",
    gender: "male",
    displayName: "Andrew",
    locale: "en-US",
  },
  {
    name: "en-US-EmmaNeural",
    gender: "female",
    displayName: "Emma",
    locale: "en-US",
  },
  {
    name: "en-US-BrianNeural",
    gender: "male",
    displayName: "Brian",
    locale: "en-US",
  },
  {
    name: "en-US-JennyNeural",
    gender: "female",
    displayName: "Jenny",
    locale: "en-US",
  },
  {
    name: "en-US-GuyNeural",
    gender: "male",
    displayName: "Guy",
    locale: "en-US",
  },
  {
    name: "en-US-AriaNeural",
    gender: "female",
    displayName: "Aria",
    locale: "en-US",
  },
  {
    name: "en-US-DavisNeural",
    gender: "male",
    displayName: "Davis",
    locale: "en-US",
  },
  {
    name: "en-US-JaneNeural",
    gender: "female",
    displayName: "Jane",
    locale: "en-US",
  },
  {
    name: "en-US-JasonNeural",
    gender: "male",
    displayName: "Jason",
    locale: "en-US",
  },
  {
    name: "en-US-KaiNeural",
    gender: "male",
    displayName: "Kai",
    locale: "en-US",
  },
  {
    name: "en-US-LunaNeural",
    gender: "female",
    displayName: "Luna",
    locale: "en-US",
  },
  {
    name: "en-US-SaraNeural",
    gender: "female",
    displayName: "Sara",
    locale: "en-US",
  },
  {
    name: "en-US-TonyNeural",
    gender: "male",
    displayName: "Tony",
    locale: "en-US",
  },
  {
    name: "en-US-NancyNeural",
    gender: "female",
    displayName: "Nancy",
    locale: "en-US",
  },
  {
    name: "en-US-CoraMultilingualNeural",
    gender: "female",
    displayName: "Cora Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-ChristopherMultilingualNeural",
    gender: "male",
    displayName: "Christopher Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-BrandonMultilingualNeural",
    gender: "male",
    displayName: "Brandon Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-AmberNeural",
    gender: "female",
    displayName: "Amber",
    locale: "en-US",
  },
  {
    name: "en-US-AnaNeural",
    gender: "female",
    displayName: "Ana",
    locale: "en-US",
  },
  {
    name: "en-US-AshleyNeural",
    gender: "female",
    displayName: "Ashley",
    locale: "en-US",
  },
  {
    name: "en-US-BrandonNeural",
    gender: "male",
    displayName: "Brandon",
    locale: "en-US",
  },
  {
    name: "en-US-ChristopherNeural",
    gender: "male",
    displayName: "Christopher",
    locale: "en-US",
  },
  {
    name: "en-US-CoraNeural",
    gender: "female",
    displayName: "Cora",
    locale: "en-US",
  },
  {
    name: "en-US-DavisMultilingualNeural",
    gender: "male",
    displayName: "Davis Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-DerekMultilingualNeural",
    gender: "male",
    displayName: "Derek Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-DustinMultilingualNeural",
    gender: "male",
    displayName: "Dustin Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-ElizabethNeural",
    gender: "female",
    displayName: "Elizabeth",
    locale: "en-US",
  },
  {
    name: "en-US-EricNeural",
    gender: "male",
    displayName: "Eric",
    locale: "en-US",
  },
  {
    name: "en-US-JacobNeural",
    gender: "male",
    displayName: "Jacob",
    locale: "en-US",
  },
  {
    name: "en-US-JennyMultilingualNeural",
    gender: "female",
    displayName: "Jenny Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-LewisMultilingualNeural",
    gender: "male",
    displayName: "Lewis Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-LolaMultilingualNeural",
    gender: "female",
    displayName: "Lola Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-MichelleNeural",
    gender: "female",
    displayName: "Michelle",
    locale: "en-US",
  },
  {
    name: "en-US-MonicaNeural",
    gender: "female",
    displayName: "Monica",
    locale: "en-US",
  },
  {
    name: "en-US-NancyMultilingualNeural",
    gender: "female",
    displayName: "Nancy Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-RogerNeural",
    gender: "male",
    displayName: "Roger",
    locale: "en-US",
  },
  {
    name: "en-US-RyanMultilingualNeural",
    gender: "male",
    displayName: "Ryan Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-SamuelMultilingualNeural",
    gender: "male",
    displayName: "Samuel Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-SerenaMultilingualNeural",
    gender: "female",
    displayName: "Serena Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-SteffanMultilingualNeural",
    gender: "male",
    displayName: "Steffan Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-SteffanNeural",
    gender: "male",
    displayName: "Steffan",
    locale: "en-US",
  },
  {
    name: "en-US-AIGenerate1Neural",
    gender: "male",
    displayName: "AIGenerate1",
    locale: "en-US",
  },
  {
    name: "en-US-AIGenerate2Neural",
    gender: "female",
    displayName: "AIGenerate2",
    locale: "en-US",
  },
  {
    name: "en-US-AshTurboMultilingualNeural",
    gender: "male",
    displayName: "Ash Turbo Multilingual",
    locale: "en-US",
  },
  {
    name: "en-US-BlueNeural",
    gender: "female",
    displayName: "Blue",
    locale: "en-US",
  },
  {
    name: "en-US-EvelynMultilingualNeural",
    gender: "female",
    displayName: "Evelyn Multilingual",
    locale: "en-US",
  },
  {
    name: "en-ZA-LeahNeural",
    gender: "female",
    displayName: "Leah",
    locale: "en-ZA",
  },
  {
    name: "en-ZA-LukeNeural",
    gender: "male",
    displayName: "Luke",
    locale: "en-ZA",
  },
  {
    name: "es-AR-ElenaNeural",
    gender: "female",
    displayName: "Elena",
    locale: "es-AR",
  },
  {
    name: "es-AR-TomasNeural",
    gender: "male",
    displayName: "Tomas",
    locale: "es-AR",
  },
  {
    name: "es-BO-SofiaNeural",
    gender: "female",
    displayName: "Sofia",
    locale: "es-BO",
  },
  {
    name: "es-BO-MarceloNeural",
    gender: "male",
    displayName: "Marcelo",
    locale: "es-BO",
  },
  {
    name: "es-CL-CatalinaNeural",
    gender: "female",
    displayName: "Catalina",
    locale: "es-CL",
  },
  {
    name: "es-CL-LorenzoNeural",
    gender: "male",
    displayName: "Lorenzo",
    locale: "es-CL",
  },
  {
    name: "es-CO-SalomeNeural",
    gender: "female",
    displayName: "Salome",
    locale: "es-CO",
  },
  {
    name: "es-CO-GonzaloNeural",
    gender: "male",
    displayName: "Gonzalo",
    locale: "es-CO",
  },
  {
    name: "es-CR-MariaNeural",
    gender: "female",
    displayName: "María",
    locale: "es-CR",
  },
  {
    name: "es-CR-JuanNeural",
    gender: "male",
    displayName: "Juan",
    locale: "es-CR",
  },
  {
    name: "es-CU-BelkysNeural",
    gender: "female",
    displayName: "Belkys",
    locale: "es-CU",
  },
  {
    name: "es-CU-ManuelNeural",
    gender: "male",
    displayName: "Manuel",
    locale: "es-CU",
  },
  {
    name: "es-DO-RamonaNeural",
    gender: "female",
    displayName: "Ramona",
    locale: "es-DO",
  },
  {
    name: "es-DO-EmilioNeural",
    gender: "male",
    displayName: "Emilio",
    locale: "es-DO",
  },
  {
    name: "es-EC-AndreaNeural",
    gender: "female",
    displayName: "Andrea",
    locale: "es-EC",
  },
  {
    name: "es-EC-LuisNeural",
    gender: "male",
    displayName: "Luis",
    locale: "es-EC",
  },
  {
    name: "es-ES-ElviraNeural",
    gender: "female",
    displayName: "Elvira",
    locale: "es-ES",
  },
  {
    name: "es-ES-AlvaroNeural",
    gender: "male",
    displayName: "Álvaro",
    locale: "es-ES",
  },
  {
    name: "es-ES-ArabellaMultilingualNeural",
    gender: "female",
    displayName: "Arabella Multilingual",
    locale: "es-ES",
  },
  {
    name: "es-ES-IsidoraMultilingualNeural",
    gender: "female",
    displayName: "Isidora Multilingual",
    locale: "es-ES",
  },
  {
    name: "es-ES-TristanMultilingualNeural",
    gender: "male",
    displayName: "Tristan Multilingual",
    locale: "es-ES",
  },
  {
    name: "es-ES-XimenaMultilingualNeural",
    gender: "female",
    displayName: "Ximena Multilingual",
    locale: "es-ES",
  },
  {
    name: "es-ES-AbrilNeural",
    gender: "female",
    displayName: "Abril",
    locale: "es-ES",
  },
  {
    name: "es-ES-ArnauNeural",
    gender: "male",
    displayName: "Arnau",
    locale: "es-ES",
  },
  {
    name: "es-ES-DarioNeural",
    gender: "male",
    displayName: "Dario",
    locale: "es-ES",
  },
  {
    name: "es-ES-EliasNeural",
    gender: "male",
    displayName: "Elias",
    locale: "es-ES",
  },
  {
    name: "es-ES-EstrellaNeural",
    gender: "female",
    displayName: "Estrella",
    locale: "es-ES",
  },
  {
    name: "es-ES-IreneNeural",
    gender: "female",
    displayName: "Irene",
    locale: "es-ES",
  },
  {
    name: "es-ES-LaiaNeural",
    gender: "female",
    displayName: "Laia",
    locale: "es-ES",
  },
  {
    name: "es-ES-LiaNeural",
    gender: "female",
    displayName: "Lia",
    locale: "es-ES",
  },
  {
    name: "es-ES-NilNeural",
    gender: "male",
    displayName: "Nil",
    locale: "es-ES",
  },
  {
    name: "es-ES-SaulNeural",
    gender: "male",
    displayName: "Saul",
    locale: "es-ES",
  },
  {
    name: "es-ES-TeoNeural",
    gender: "male",
    displayName: "Teo",
    locale: "es-ES",
  },
  {
    name: "es-ES-TrianaNeural",
    gender: "female",
    displayName: "Triana",
    locale: "es-ES",
  },
  {
    name: "es-ES-VeraNeural",
    gender: "female",
    displayName: "Vera",
    locale: "es-ES",
  },
  {
    name: "es-ES-XimenaNeural",
    gender: "female",
    displayName: "Ximena",
    locale: "es-ES",
  },
  {
    name: "es-GQ-TeresaNeural",
    gender: "female",
    displayName: "Teresa",
    locale: "es-GQ",
  },
  {
    name: "es-GQ-JavierNeural",
    gender: "male",
    displayName: "Javier",
    locale: "es-GQ",
  },
  {
    name: "es-GT-MartaNeural",
    gender: "female",
    displayName: "Marta",
    locale: "es-GT",
  },
  {
    name: "es-GT-AndresNeural",
    gender: "male",
    displayName: "Andrés",
    locale: "es-GT",
  },
  {
    name: "es-HN-KarlaNeural",
    gender: "female",
    displayName: "Karla",
    locale: "es-HN",
  },
  {
    name: "es-HN-CarlosNeural",
    gender: "male",
    displayName: "Carlos",
    locale: "es-HN",
  },
  {
    name: "es-MX-DaliaNeural",
    gender: "female",
    displayName: "Dalia",
    locale: "es-MX",
  },
  {
    name: "es-MX-JorgeNeural",
    gender: "male",
    displayName: "Jorge",
    locale: "es-MX",
  },
  {
    name: "es-MX-DaliaMultilingualNeural",
    gender: "female",
    displayName: "Dalia Multilingual",
    locale: "es-MX",
  },
  {
    name: "es-MX-JorgeMultilingualNeural",
    gender: "male",
    displayName: "Jorge Multilingual",
    locale: "es-MX",
  },
  {
    name: "es-MX-BeatrizNeural",
    gender: "female",
    displayName: "Beatriz",
    locale: "es-MX",
  },
  {
    name: "es-MX-CandelaNeural",
    gender: "female",
    displayName: "Candela",
    locale: "es-MX",
  },
  {
    name: "es-MX-CarlotaNeural",
    gender: "female",
    displayName: "Carlota",
    locale: "es-MX",
  },
  {
    name: "es-MX-CecilioNeural",
    gender: "male",
    displayName: "Cecilio",
    locale: "es-MX",
  },
  {
    name: "es-MX-GerardoNeural",
    gender: "male",
    displayName: "Gerardo",
    locale: "es-MX",
  },
  {
    name: "es-MX-LarissaNeural",
    gender: "female",
    displayName: "Larissa",
    locale: "es-MX",
  },
  {
    name: "es-MX-LibertoNeural",
    gender: "male",
    displayName: "Liberto",
    locale: "es-MX",
  },
  {
    name: "es-MX-LucianoNeural",
    gender: "male",
    displayName: "Luciano",
    locale: "es-MX",
  },
  {
    name: "es-MX-MarinaNeural",
    gender: "female",
    displayName: "Marina",
    locale: "es-MX",
  },
  {
    name: "es-MX-NuriaNeural",
    gender: "female",
    displayName: "Nuria",
    locale: "es-MX",
  },
  {
    name: "es-MX-PelayoNeural",
    gender: "male",
    displayName: "Pelayo",
    locale: "es-MX",
  },
  {
    name: "es-MX-RenataNeural",
    gender: "female",
    displayName: "Renata",
    locale: "es-MX",
  },
  {
    name: "es-MX-YagoNeural",
    gender: "male",
    displayName: "Yago",
    locale: "es-MX",
  },
  {
    name: "es-NI-YolandaNeural",
    gender: "female",
    displayName: "Yolanda",
    locale: "es-NI",
  },
  {
    name: "es-NI-FedericoNeural",
    gender: "male",
    displayName: "Federico",
    locale: "es-NI",
  },
  {
    name: "es-PA-MargaritaNeural",
    gender: "female",
    displayName: "Margarita",
    locale: "es-PA",
  },
  {
    name: "es-PA-RobertoNeural",
    gender: "male",
    displayName: "Roberto",
    locale: "es-PA",
  },
  {
    name: "es-PE-CamilaNeural",
    gender: "female",
    displayName: "Camila",
    locale: "es-PE",
  },
  {
    name: "es-PE-AlexNeural",
    gender: "male",
    displayName: "Alex",
    locale: "es-PE",
  },
  {
    name: "es-PR-KarinaNeural",
    gender: "female",
    displayName: "Karina",
    locale: "es-PR",
  },
  {
    name: "es-PR-VictorNeural",
    gender: "male",
    displayName: "Víctor",
    locale: "es-PR",
  },
  {
    name: "es-PY-TaniaNeural",
    gender: "female",
    displayName: "Tania",
    locale: "es-PY",
  },
  {
    name: "es-PY-MarioNeural",
    gender: "male",
    displayName: "Mario",
    locale: "es-PY",
  },
  {
    name: "es-SV-LorenaNeural",
    gender: "female",
    displayName: "Lorena",
    locale: "es-SV",
  },
  {
    name: "es-SV-RodrigoNeural",
    gender: "male",
    displayName: "Rodrigo",
    locale: "es-SV",
  },
  {
    name: "es-US-PalomaNeural",
    gender: "female",
    displayName: "Paloma",
    locale: "es-US",
  },
  {
    name: "es-US-AlonsoNeural",
    gender: "male",
    displayName: "Alonso",
    locale: "es-US",
  },
  {
    name: "es-UY-ValentinaNeural",
    gender: "female",
    displayName: "Valentina",
    locale: "es-UY",
  },
  {
    name: "es-UY-MateoNeural",
    gender: "male",
    displayName: "Mateo",
    locale: "es-UY",
  },
  {
    name: "es-VE-PaolaNeural",
    gender: "female",
    displayName: "Paola",
    locale: "es-VE",
  },
  {
    name: "es-VE-SebastianNeural",
    gender: "male",
    displayName: "Sebastián",
    locale: "es-VE",
  },
  {
    name: "et-EE-AnuNeural",
    gender: "female",
    displayName: "Anu",
    locale: "et-EE",
  },
  {
    name: "et-EE-KertNeural",
    gender: "male",
    displayName: "Kert",
    locale: "et-EE",
  },
  {
    name: "eu-ES-AinhoaNeural",
    gender: "female",
    displayName: "Ainhoa",
    locale: "eu-ES",
  },
  {
    name: "eu-ES-AnderNeural",
    gender: "male",
    displayName: "Ander",
    locale: "eu-ES",
  },
  {
    name: "fa-IR-DilaraNeural",
    gender: "female",
    displayName: "دلارا",
    locale: "fa-IR",
  },
  {
    name: "fa-IR-FaridNeural",
    gender: "male",
    displayName: "فرید",
    locale: "fa-IR",
  },
  {
    name: "fi-FI-SelmaNeural",
    gender: "female",
    displayName: "Selma",
    locale: "fi-FI",
  },
  {
    name: "fi-FI-HarriNeural",
    gender: "male",
    displayName: "Harri",
    locale: "fi-FI",
  },
  {
    name: "fi-FI-NooraNeural",
    gender: "female",
    displayName: "Noora",
    locale: "fi-FI",
  },
  {
    name: "fil-PH-BlessicaNeural",
    gender: "female",
    displayName: "Blessica",
    locale: "fil-PH",
  },
  {
    name: "fil-PH-AngeloNeural",
    gender: "male",
    displayName: "Angelo",
    locale: "fil-PH",
  },
  {
    name: "fr-BE-CharlineNeural",
    gender: "female",
    displayName: "Charline",
    locale: "fr-BE",
  },
  {
    name: "fr-BE-GerardNeural",
    gender: "male",
    displayName: "Gerard",
    locale: "fr-BE",
  },
  {
    name: "fr-CA-SylvieNeural",
    gender: "female",
    displayName: "Sylvie",
    locale: "fr-CA",
  },
  {
    name: "fr-CA-JeanNeural",
    gender: "male",
    displayName: "Jean",
    locale: "fr-CA",
  },
  {
    name: "fr-CA-AntoineNeural",
    gender: "male",
    displayName: "Antoine",
    locale: "fr-CA",
  },
  {
    name: "fr-CA-ThierryNeural",
    gender: "male",
    displayName: "Thierry",
    locale: "fr-CA",
  },
  {
    name: "fr-CH-ArianeNeural",
    gender: "female",
    displayName: "Ariane",
    locale: "fr-CH",
  },
  {
    name: "fr-CH-FabriceNeural",
    gender: "male",
    displayName: "Fabrice",
    locale: "fr-CH",
  },
  {
    name: "fr-FR-DeniseNeural",
    gender: "female",
    displayName: "Denise",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-HenriNeural",
    gender: "male",
    displayName: "Henri",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-VivienneMultilingualNeural",
    gender: "female",
    displayName: "Vivienne Multilingue",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-RemyMultilingualNeural",
    gender: "male",
    displayName: "Rémy Multilingue",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-LucienMultilingualNeural",
    gender: "male",
    displayName: "Lucien Multilingual",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-AlainNeural",
    gender: "male",
    displayName: "Alain",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-BrigitteNeural",
    gender: "female",
    displayName: "Brigitte",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-CelesteNeural",
    gender: "female",
    displayName: "Celeste",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-ClaudeNeural",
    gender: "male",
    displayName: "Claude",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-CoralieNeural",
    gender: "female",
    displayName: "Coralie",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-EloiseNeural",
    gender: "female",
    displayName: "Eloise",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-JacquelineNeural",
    gender: "female",
    displayName: "Jacqueline",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-JeromeNeural",
    gender: "male",
    displayName: "Jerome",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-JosephineNeural",
    gender: "female",
    displayName: "Josephine",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-MauriceNeural",
    gender: "male",
    displayName: "Maurice",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-YvesNeural",
    gender: "male",
    displayName: "Yves",
    locale: "fr-FR",
  },
  {
    name: "fr-FR-YvetteNeural",
    gender: "female",
    displayName: "Yvette",
    locale: "fr-FR",
  },
  {
    name: "ga-IE-OrlaNeural",
    gender: "female",
    displayName: "Orla",
    locale: "ga-IE",
  },
  {
    name: "ga-IE-ColmNeural",
    gender: "male",
    displayName: "Colm",
    locale: "ga-IE",
  },
  {
    name: "gl-ES-SabelaNeural",
    gender: "female",
    displayName: "Sabela",
    locale: "gl-ES",
  },
  {
    name: "gl-ES-RoiNeural",
    gender: "male",
    displayName: "Roi",
    locale: "gl-ES",
  },
  {
    name: "gu-IN-DhwaniNeural",
    gender: "female",
    displayName: "ધ્વની",
    locale: "gu-IN",
  },
  {
    name: "gu-IN-NiranjanNeural",
    gender: "male",
    displayName: "નિરંજન",
    locale: "gu-IN",
  },
  {
    name: "he-IL-HilaNeural",
    gender: "female",
    displayName: "הילה",
    locale: "he-IL",
  },
  {
    name: "he-IL-AvriNeural",
    gender: "male",
    displayName: "אברי",
    locale: "he-IL",
  },
  {
    name: "hi-IN-AaravNeural",
    gender: "male",
    displayName: "आरव ",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-AnanyaNeural",
    gender: "female",
    displayName: "अनन्या",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-AartiNeural",
    gender: "female",
    displayName: "आरती",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-ArjunNeural",
    gender: "male",
    displayName: "अर्जुन",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-KavyaNeural",
    gender: "female",
    displayName: "काव्या",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-KunalNeural",
    gender: "male",
    displayName: "कुनाल ",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-RehaanNeural",
    gender: "male",
    displayName: "रेहान",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-SwaraNeural",
    gender: "female",
    displayName: "स्वरा",
    locale: "hi-IN",
  },
  {
    name: "hi-IN-MadhurNeural",
    gender: "male",
    displayName: "मधुर",
    locale: "hi-IN",
  },
  {
    name: "hr-HR-GabrijelaNeural",
    gender: "female",
    displayName: "Gabrijela",
    locale: "hr-HR",
  },
  {
    name: "hr-HR-SreckoNeural",
    gender: "male",
    displayName: "Srećko",
    locale: "hr-HR",
  },
  {
    name: "hu-HU-NoemiNeural",
    gender: "female",
    displayName: "Noémi",
    locale: "hu-HU",
  },
  {
    name: "hu-HU-TamasNeural",
    gender: "male",
    displayName: "Tamás",
    locale: "hu-HU",
  },
  {
    name: "hy-AM-AnahitNeural",
    gender: "female",
    displayName: "Անահիտ",
    locale: "hy-AM",
  },
  {
    name: "hy-AM-HaykNeural",
    gender: "male",
    displayName: "Հայկ",
    locale: "hy-AM",
  },
  {
    name: "id-ID-GadisNeural",
    gender: "female",
    displayName: "Gadis",
    locale: "id-ID",
  },
  {
    name: "id-ID-ArdiNeural",
    gender: "male",
    displayName: "Ardi",
    locale: "id-ID",
  },
  {
    name: "is-IS-GudrunNeural",
    gender: "female",
    displayName: "Guðrún",
    locale: "is-IS",
  },
  {
    name: "is-IS-GunnarNeural",
    gender: "male",
    displayName: "Gunnar",
    locale: "is-IS",
  },
  {
    name: "it-IT-ElsaNeural",
    gender: "female",
    displayName: "Elsa",
    locale: "it-IT",
  },
  {
    name: "it-IT-IsabellaNeural",
    gender: "female",
    displayName: "Isabella",
    locale: "it-IT",
  },
  {
    name: "it-IT-DiegoNeural",
    gender: "male",
    displayName: "Diego",
    locale: "it-IT",
  },
  {
    name: "it-IT-AlessioMultilingualNeural",
    gender: "male",
    displayName: "Alessio Multilingual",
    locale: "it-IT",
  },
  {
    name: "it-IT-IsabellaMultilingualNeural",
    gender: "female",
    displayName: "Isabella Multilingual",
    locale: "it-IT",
  },
  {
    name: "it-IT-GiuseppeMultilingualNeural",
    gender: "male",
    displayName: "Giuseppe Multilingual",
    locale: "it-IT",
  },
  {
    name: "it-IT-MarcelloMultilingualNeural",
    gender: "male",
    displayName: "Marcello Multilingual",
    locale: "it-IT",
  },
  {
    name: "it-IT-BenignoNeural",
    gender: "male",
    displayName: "Benigno",
    locale: "it-IT",
  },
  {
    name: "it-IT-CalimeroNeural",
    gender: "male",
    displayName: "Calimero",
    locale: "it-IT",
  },
  {
    name: "it-IT-CataldoNeural",
    gender: "male",
    displayName: "Cataldo",
    locale: "it-IT",
  },
  {
    name: "it-IT-FabiolaNeural",
    gender: "female",
    displayName: "Fabiola",
    locale: "it-IT",
  },
  {
    name: "it-IT-FiammaNeural",
    gender: "female",
    displayName: "Fiamma",
    locale: "it-IT",
  },
  {
    name: "it-IT-GianniNeural",
    gender: "male",
    displayName: "Gianni",
    locale: "it-IT",
  },
  {
    name: "it-IT-GiuseppeNeural",
    gender: "male",
    displayName: "Giuseppe",
    locale: "it-IT",
  },
  {
    name: "it-IT-ImeldaNeural",
    gender: "female",
    displayName: "Imelda",
    locale: "it-IT",
  },
  {
    name: "it-IT-IrmaNeural",
    gender: "female",
    displayName: "Irma",
    locale: "it-IT",
  },
  {
    name: "it-IT-LisandroNeural",
    gender: "male",
    displayName: "Lisandro",
    locale: "it-IT",
  },
  {
    name: "it-IT-PalmiraNeural",
    gender: "female",
    displayName: "Palmira",
    locale: "it-IT",
  },
  {
    name: "it-IT-PierinaNeural",
    gender: "female",
    displayName: "Pierina",
    locale: "it-IT",
  },
  {
    name: "it-IT-RinaldoNeural",
    gender: "male",
    displayName: "Rinaldo",
    locale: "it-IT",
  },
  {
    name: "iu-Cans-CA-SiqiniqNeural",
    gender: "female",
    displayName: "ᓯᕿᓂᖅ",
    locale: "iu-Cans-CA",
  },
  {
    name: "iu-Cans-CA-TaqqiqNeural",
    gender: "male",
    displayName: "ᑕᖅᑭᖅ",
    locale: "iu-Cans-CA",
  },
  {
    name: "iu-Latn-CA-SiqiniqNeural",
    gender: "female",
    displayName: "ᓯᕿᓂᖅ",
    locale: "iu-Latn-CA",
  },
  {
    name: "iu-Latn-CA-TaqqiqNeural",
    gender: "male",
    displayName: "ᑕᖅᑭᖅ",
    locale: "iu-Latn-CA",
  },
  {
    name: "ja-JP-NanamiNeural",
    gender: "female",
    displayName: "七海",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-KeitaNeural",
    gender: "male",
    displayName: "圭太",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-AoiNeural",
    gender: "female",
    displayName: "碧衣",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-DaichiNeural",
    gender: "male",
    displayName: "大智",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-MayuNeural",
    gender: "female",
    displayName: "真夕",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-NaokiNeural",
    gender: "male",
    displayName: "直紀",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-ShioriNeural",
    gender: "female",
    displayName: "志織",
    locale: "ja-JP",
  },
  {
    name: "ja-JP-MasaruMultilingualNeural",
    gender: "male",
    displayName: "勝 多言語",
    locale: "ja-JP",
  },
  {
    name: "jv-ID-SitiNeural",
    gender: "female",
    displayName: "Siti",
    locale: "jv-ID",
  },
  {
    name: "jv-ID-DimasNeural",
    gender: "male",
    displayName: "Dimas",
    locale: "jv-ID",
  },
  {
    name: "ka-GE-EkaNeural",
    gender: "female",
    displayName: "ეკა",
    locale: "ka-GE",
  },
  {
    name: "ka-GE-GiorgiNeural",
    gender: "male",
    displayName: "გიორგი",
    locale: "ka-GE",
  },
  {
    name: "kk-KZ-AigulNeural",
    gender: "female",
    displayName: "Айгүл",
    locale: "kk-KZ",
  },
  {
    name: "kk-KZ-DauletNeural",
    gender: "male",
    displayName: "Дәулет",
    locale: "kk-KZ",
  },
  {
    name: "km-KH-SreymomNeural",
    gender: "female",
    displayName: "ស្រីមុំ",
    locale: "km-KH",
  },
  {
    name: "km-KH-PisethNeural",
    gender: "male",
    displayName: "ពិសិដ្ឋ",
    locale: "km-KH",
  },
  {
    name: "kn-IN-SapnaNeural",
    gender: "female",
    displayName: "ಸಪ್ನಾ",
    locale: "kn-IN",
  },
  {
    name: "kn-IN-GaganNeural",
    gender: "male",
    displayName: "ಗಗನ್",
    locale: "kn-IN",
  },
  {
    name: "ko-KR-SunHiNeural",
    gender: "female",
    displayName: "선히",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-InJoonNeural",
    gender: "male",
    displayName: "인준",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-HyunsuMultilingualNeural",
    gender: "male",
    displayName: "Hyunsu Multilingual",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-BongJinNeural",
    gender: "male",
    displayName: "봉진",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-GookMinNeural",
    gender: "male",
    displayName: "국민",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-HyunsuNeural",
    gender: "male",
    displayName: "현수",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-JiMinNeural",
    gender: "female",
    displayName: "지민",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-SeoHyeonNeural",
    gender: "female",
    displayName: "서현",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-SoonBokNeural",
    gender: "female",
    displayName: "순복",
    locale: "ko-KR",
  },
  {
    name: "ko-KR-YuJinNeural",
    gender: "female",
    displayName: "유진",
    locale: "ko-KR",
  },
  {
    name: "lo-LA-KeomanyNeural",
    gender: "female",
    displayName: "ແກ້ວມະນີ",
    locale: "lo-LA",
  },
  {
    name: "lo-LA-ChanthavongNeural",
    gender: "male",
    displayName: "ຈັນທະວົງ",
    locale: "lo-LA",
  },
  {
    name: "lt-LT-OnaNeural",
    gender: "female",
    displayName: "Ona",
    locale: "lt-LT",
  },
  {
    name: "lt-LT-LeonasNeural",
    gender: "male",
    displayName: "Leonas",
    locale: "lt-LT",
  },
  {
    name: "lv-LV-EveritaNeural",
    gender: "female",
    displayName: "Everita",
    locale: "lv-LV",
  },
  {
    name: "lv-LV-NilsNeural",
    gender: "male",
    displayName: "Nils",
    locale: "lv-LV",
  },
  {
    name: "mk-MK-MarijaNeural",
    gender: "female",
    displayName: "Марија",
    locale: "mk-MK",
  },
  {
    name: "mk-MK-AleksandarNeural",
    gender: "male",
    displayName: "Александар",
    locale: "mk-MK",
  },
  {
    name: "ml-IN-SobhanaNeural",
    gender: "female",
    displayName: "ശോഭന",
    locale: "ml-IN",
  },
  {
    name: "ml-IN-MidhunNeural",
    gender: "male",
    displayName: "മിഥുൻ",
    locale: "ml-IN",
  },
  {
    name: "mn-MN-YesuiNeural",
    gender: "female",
    displayName: "Есүй",
    locale: "mn-MN",
  },
  {
    name: "mn-MN-BataaNeural",
    gender: "male",
    displayName: "Батаа",
    locale: "mn-MN",
  },
  {
    name: "mr-IN-AarohiNeural",
    gender: "female",
    displayName: "आरोही",
    locale: "mr-IN",
  },
  {
    name: "mr-IN-ManoharNeural",
    gender: "male",
    displayName: "मनोहर",
    locale: "mr-IN",
  },
  {
    name: "ms-MY-YasminNeural",
    gender: "female",
    displayName: "Yasmin",
    locale: "ms-MY",
  },
  {
    name: "ms-MY-OsmanNeural",
    gender: "male",
    displayName: "Osman",
    locale: "ms-MY",
  },
  {
    name: "mt-MT-GraceNeural",
    gender: "female",
    displayName: "Grace",
    locale: "mt-MT",
  },
  {
    name: "mt-MT-JosephNeural",
    gender: "male",
    displayName: "Joseph",
    locale: "mt-MT",
  },
  {
    name: "my-MM-NilarNeural",
    gender: "female",
    displayName: "နီလာ",
    locale: "my-MM",
  },
  {
    name: "my-MM-ThihaNeural",
    gender: "male",
    displayName: "သီဟ",
    locale: "my-MM",
  },
  {
    name: "nb-NO-PernilleNeural",
    gender: "female",
    displayName: "Pernille",
    locale: "nb-NO",
  },
  {
    name: "nb-NO-FinnNeural",
    gender: "male",
    displayName: "Finn",
    locale: "nb-NO",
  },
  {
    name: "nb-NO-IselinNeural",
    gender: "female",
    displayName: "Iselin",
    locale: "nb-NO",
  },
  {
    name: "ne-NP-HemkalaNeural",
    gender: "female",
    displayName: "हेमकला",
    locale: "ne-NP",
  },
  {
    name: "ne-NP-SagarNeural",
    gender: "male",
    displayName: "सागर",
    locale: "ne-NP",
  },
  {
    name: "nl-BE-DenaNeural",
    gender: "female",
    displayName: "Dena",
    locale: "nl-BE",
  },
  {
    name: "nl-BE-ArnaudNeural",
    gender: "male",
    displayName: "Arnaud",
    locale: "nl-BE",
  },
  {
    name: "nl-NL-FennaNeural",
    gender: "female",
    displayName: "Fenna",
    locale: "nl-NL",
  },
  {
    name: "nl-NL-MaartenNeural",
    gender: "male",
    displayName: "Maarten",
    locale: "nl-NL",
  },
  {
    name: "nl-NL-ColetteNeural",
    gender: "female",
    displayName: "Colette",
    locale: "nl-NL",
  },
  {
    name: "or-IN-SubhasiniNeural",
    gender: "female",
    displayName: "ସୁଭାସିନୀ",
    locale: "or-IN",
  },
  {
    name: "or-IN-SukantNeural",
    gender: "male",
    displayName: "ସୁକାନ୍ତ",
    locale: "or-IN",
  },
  {
    name: "pa-IN-OjasNeural",
    gender: "male",
    displayName: "ਓਜਸ",
    locale: "pa-IN",
  },
  {
    name: "pa-IN-VaaniNeural",
    gender: "female",
    displayName: "ਵਾਨੀ",
    locale: "pa-IN",
  },
  {
    name: "pl-PL-AgnieszkaNeural",
    gender: "female",
    displayName: "Agnieszka",
    locale: "pl-PL",
  },
  {
    name: "pl-PL-MarekNeural",
    gender: "male",
    displayName: "Marek",
    locale: "pl-PL",
  },
  {
    name: "pl-PL-ZofiaNeural",
    gender: "female",
    displayName: "Zofia",
    locale: "pl-PL",
  },
  {
    name: "ps-AF-LatifaNeural",
    gender: "female",
    displayName: "لطيفه",
    locale: "ps-AF",
  },
  {
    name: "ps-AF-GulNawazNeural",
    gender: "male",
    displayName: " ګل نواز",
    locale: "ps-AF",
  },
  {
    name: "pt-BR-FranciscaNeural",
    gender: "female",
    displayName: "Francisca",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-AntonioNeural",
    gender: "male",
    displayName: "Antônio",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-MacerioMultilingualNeural",
    gender: "male",
    displayName: "Macerio Multilingual",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-ThalitaMultilingualNeural",
    gender: "female",
    displayName: "Thalita multilíngue",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-BrendaNeural",
    gender: "female",
    displayName: "Brenda",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-DonatoNeural",
    gender: "male",
    displayName: "Donato",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-ElzaNeural",
    gender: "female",
    displayName: "Elza",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-FabioNeural",
    gender: "male",
    displayName: "Fabio",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-GiovannaNeural",
    gender: "female",
    displayName: "Giovanna",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-HumbertoNeural",
    gender: "male",
    displayName: "Humberto",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-JulioNeural",
    gender: "male",
    displayName: "Julio",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-LeilaNeural",
    gender: "female",
    displayName: "Leila",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-LeticiaNeural",
    gender: "female",
    displayName: "Leticia",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-ManuelaNeural",
    gender: "female",
    displayName: "Manuela",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-NicolauNeural",
    gender: "male",
    displayName: "Nicolau",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-ThalitaNeural",
    gender: "female",
    displayName: "Thalita",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-ValerioNeural",
    gender: "male",
    displayName: "Valerio",
    locale: "pt-BR",
  },
  {
    name: "pt-BR-YaraNeural",
    gender: "female",
    displayName: "Yara",
    locale: "pt-BR",
  },
  {
    name: "pt-PT-RaquelNeural",
    gender: "female",
    displayName: "Raquel",
    locale: "pt-PT",
  },
  {
    name: "pt-PT-DuarteNeural",
    gender: "male",
    displayName: "Duarte",
    locale: "pt-PT",
  },
  {
    name: "pt-PT-FernandaNeural",
    gender: "female",
    displayName: "Fernanda",
    locale: "pt-PT",
  },
  {
    name: "ro-RO-AlinaNeural",
    gender: "female",
    displayName: "Alina",
    locale: "ro-RO",
  },
  {
    name: "ro-RO-EmilNeural",
    gender: "male",
    displayName: "Emil",
    locale: "ro-RO",
  },
  {
    name: "ru-RU-SvetlanaNeural",
    gender: "female",
    displayName: "Светлана",
    locale: "ru-RU",
  },
  {
    name: "ru-RU-DmitryNeural",
    gender: "male",
    displayName: "Дмитрий",
    locale: "ru-RU",
  },
  {
    name: "ru-RU-DariyaNeural",
    gender: "female",
    displayName: "Дария",
    locale: "ru-RU",
  },
  {
    name: "si-LK-ThiliniNeural",
    gender: "female",
    displayName: "තිළිණි",
    locale: "si-LK",
  },
  {
    name: "si-LK-SameeraNeural",
    gender: "male",
    displayName: "සමීර",
    locale: "si-LK",
  },
  {
    name: "sk-SK-ViktoriaNeural",
    gender: "female",
    displayName: "Viktória",
    locale: "sk-SK",
  },
  {
    name: "sk-SK-LukasNeural",
    gender: "male",
    displayName: "Lukáš",
    locale: "sk-SK",
  },
  {
    name: "sl-SI-PetraNeural",
    gender: "female",
    displayName: "Petra",
    locale: "sl-SI",
  },
  {
    name: "sl-SI-RokNeural",
    gender: "male",
    displayName: "Rok",
    locale: "sl-SI",
  },
  {
    name: "so-SO-UbaxNeural",
    gender: "female",
    displayName: "Ubax",
    locale: "so-SO",
  },
  {
    name: "so-SO-MuuseNeural",
    gender: "male",
    displayName: "Muuse",
    locale: "so-SO",
  },
  {
    name: "sq-AL-AnilaNeural",
    gender: "female",
    displayName: "Anila",
    locale: "sq-AL",
  },
  {
    name: "sq-AL-IlirNeural",
    gender: "male",
    displayName: "Ilir",
    locale: "sq-AL",
  },
  {
    name: "sr-Latn-RS-NicholasNeural",
    gender: "male",
    displayName: "Nicholas",
    locale: "sr-Latn-RS",
  },
  {
    name: "sr-Latn-RS-SophieNeural",
    gender: "female",
    displayName: "Sophie",
    locale: "sr-Latn-RS",
  },
  {
    name: "sr-RS-SophieNeural",
    gender: "female",
    displayName: "Софија",
    locale: "sr-RS",
  },
  {
    name: "sr-RS-NicholasNeural",
    gender: "male",
    displayName: "Никола",
    locale: "sr-RS",
  },
  {
    name: "su-ID-TutiNeural",
    gender: "female",
    displayName: "Tuti",
    locale: "su-ID",
  },
  {
    name: "su-ID-JajangNeural",
    gender: "male",
    displayName: "Jajang",
    locale: "su-ID",
  },
  {
    name: "sv-SE-SofieNeural",
    gender: "female",
    displayName: "Sofie",
    locale: "sv-SE",
  },
  {
    name: "sv-SE-MattiasNeural",
    gender: "male",
    displayName: "Mattias",
    locale: "sv-SE",
  },
  {
    name: "sv-SE-HilleviNeural",
    gender: "female",
    displayName: "Hillevi",
    locale: "sv-SE",
  },
  {
    name: "sw-KE-ZuriNeural",
    gender: "female",
    displayName: "Zuri",
    locale: "sw-KE",
  },
  {
    name: "sw-KE-RafikiNeural",
    gender: "male",
    displayName: "Rafiki",
    locale: "sw-KE",
  },
  {
    name: "sw-TZ-RehemaNeural",
    gender: "female",
    displayName: "Rehema",
    locale: "sw-TZ",
  },
  {
    name: "sw-TZ-DaudiNeural",
    gender: "male",
    displayName: "Daudi",
    locale: "sw-TZ",
  },
  {
    name: "ta-IN-PallaviNeural",
    gender: "female",
    displayName: "பல்லவி",
    locale: "ta-IN",
  },
  {
    name: "ta-IN-ValluvarNeural",
    gender: "male",
    displayName: "வள்ளுவர்",
    locale: "ta-IN",
  },
  {
    name: "ta-LK-SaranyaNeural",
    gender: "female",
    displayName: "சரண்யா",
    locale: "ta-LK",
  },
  {
    name: "ta-LK-KumarNeural",
    gender: "male",
    displayName: "குமார்",
    locale: "ta-LK",
  },
  {
    name: "ta-MY-KaniNeural",
    gender: "female",
    displayName: "கனி",
    locale: "ta-MY",
  },
  {
    name: "ta-MY-SuryaNeural",
    gender: "male",
    displayName: "சூர்யா",
    locale: "ta-MY",
  },
  {
    name: "ta-SG-VenbaNeural",
    gender: "female",
    displayName: "வெண்பா",
    locale: "ta-SG",
  },
  {
    name: "ta-SG-AnbuNeural",
    gender: "male",
    displayName: "அன்பு",
    locale: "ta-SG",
  },
  {
    name: "te-IN-ShrutiNeural",
    gender: "female",
    displayName: "శ్రుతి",
    locale: "te-IN",
  },
  {
    name: "te-IN-MohanNeural",
    gender: "male",
    displayName: "మోహన్",
    locale: "te-IN",
  },
  {
    name: "th-TH-PremwadeeNeural",
    gender: "female",
    displayName: "เปรมวดี",
    locale: "th-TH",
  },
  {
    name: "th-TH-NiwatNeural",
    gender: "male",
    displayName: "นิวัฒน์",
    locale: "th-TH",
  },
  {
    name: "th-TH-AcharaNeural",
    gender: "female",
    displayName: "อัจฉรา",
    locale: "th-TH",
  },
  {
    name: "tr-TR-EmelNeural",
    gender: "female",
    displayName: "Emel",
    locale: "tr-TR",
  },
  {
    name: "tr-TR-AhmetNeural",
    gender: "male",
    displayName: "Ahmet",
    locale: "tr-TR",
  },
  {
    name: "uk-UA-PolinaNeural",
    gender: "female",
    displayName: "Поліна",
    locale: "uk-UA",
  },
  {
    name: "uk-UA-OstapNeural",
    gender: "male",
    displayName: "Остап",
    locale: "uk-UA",
  },
  {
    name: "ur-IN-GulNeural",
    gender: "female",
    displayName: "گل",
    locale: "ur-IN",
  },
  {
    name: "ur-IN-SalmanNeural",
    gender: "male",
    displayName: "سلمان",
    locale: "ur-IN",
  },
  {
    name: "ur-PK-UzmaNeural",
    gender: "female",
    displayName: "عظمیٰ",
    locale: "ur-PK",
  },
  {
    name: "ur-PK-AsadNeural",
    gender: "male",
    displayName: "اسد",
    locale: "ur-PK",
  },
  {
    name: "uz-UZ-MadinaNeural",
    gender: "female",
    displayName: "Madina",
    locale: "uz-UZ",
  },
  {
    name: "uz-UZ-SardorNeural",
    gender: "male",
    displayName: "Sardor",
    locale: "uz-UZ",
  },
  {
    name: "vi-VN-HoaiMyNeural",
    gender: "female",
    displayName: "Hoài My",
    locale: "vi-VN",
  },
  {
    name: "vi-VN-NamMinhNeural",
    gender: "male",
    displayName: "Nam Minh",
    locale: "vi-VN",
  },
  {
    name: "wuu-CN-XiaotongNeural",
    gender: "female",
    displayName: "晓彤",
    locale: "wuu-CN",
  },
  {
    name: "wuu-CN-YunzheNeural",
    gender: "male",
    displayName: "云哲",
    locale: "wuu-CN",
  },
  {
    name: "yue-CN-XiaoMinNeural",
    gender: "female",
    displayName: "晓敏",
    locale: "yue-CN",
  },
  {
    name: "yue-CN-YunSongNeural",
    gender: "male",
    displayName: "云松",
    locale: "yue-CN",
  },
  {
    name: "zh-CN-XiaoxiaoNeural",
    gender: "female",
    displayName: "晓晓",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunxiNeural",
    gender: "male",
    displayName: "云希",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunjianNeural",
    gender: "male",
    displayName: "云健",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoyiNeural",
    gender: "female",
    displayName: "晓伊",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunyangNeural",
    gender: "male",
    displayName: "云扬",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaochenNeural",
    gender: "female",
    displayName: "晓辰",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaochenMultilingualNeural",
    gender: "female",
    displayName: "晓辰 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaohanNeural",
    gender: "female",
    displayName: "晓涵",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaomengNeural",
    gender: "female",
    displayName: "晓梦",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaomoNeural",
    gender: "female",
    displayName: "晓墨",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoqiuNeural",
    gender: "female",
    displayName: "晓秋",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaorouNeural",
    gender: "female",
    displayName: "晓柔",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoruiNeural",
    gender: "female",
    displayName: "晓睿",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoshuangNeural",
    gender: "female",
    displayName: "晓双",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoxiaoDialectsNeural",
    gender: "female",
    displayName: "晓晓 方言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoxiaoMultilingualNeural",
    gender: "female",
    displayName: "晓晓 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoyanNeural",
    gender: "female",
    displayName: "晓颜",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoyouNeural",
    gender: "female",
    displayName: "晓悠",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaoyuMultilingualNeural",
    gender: "female",
    displayName: "晓宇 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-XiaozhenNeural",
    gender: "female",
    displayName: "晓甄",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunfengNeural",
    gender: "male",
    displayName: "云枫",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunhaoNeural",
    gender: "male",
    displayName: "云皓",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunjieNeural",
    gender: "male",
    displayName: "云杰",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunxiaNeural",
    gender: "male",
    displayName: "云夏",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunxiaoMultilingualNeural",
    gender: "male",
    displayName: "云霄 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunyeNeural",
    gender: "male",
    displayName: "云野",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunyiMultilingualNeural",
    gender: "male",
    displayName: "云逸 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunzeNeural",
    gender: "male",
    displayName: "云泽",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-YunfanMultilingualNeural",
    gender: "male",
    displayName: "云帆 多语言",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-guangxi-YunqiNeural",
    gender: "male",
    displayName: "云奇 广西",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-henan-YundengNeural",
    gender: "male",
    displayName: "云登",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-liaoning-XiaobeiNeural",
    gender: "female",
    displayName: "晓北 辽宁",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-liaoning-YunbiaoNeural",
    gender: "male",
    displayName: "云彪 辽宁",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-shaanxi-XiaoniNeural",
    gender: "female",
    displayName: "晓妮",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-shandong-YunxiangNeural",
    gender: "male",
    displayName: "云翔",
    locale: "zh-CN",
  },
  {
    name: "zh-CN-sichuan-YunxiNeural",
    gender: "male",
    displayName: "云希 四川",
    locale: "zh-CN",
  },
  {
    name: "zh-HK-HiuMaanNeural",
    gender: "female",
    displayName: "曉曼",
    locale: "zh-HK",
  },
  {
    name: "zh-HK-WanLungNeural",
    gender: "male",
    displayName: "雲龍",
    locale: "zh-HK",
  },
  {
    name: "zh-HK-HiuGaaiNeural",
    gender: "female",
    displayName: "曉佳",
    locale: "zh-HK",
  },
  {
    name: "zh-TW-HsiaoChenNeural",
    gender: "female",
    displayName: "曉臻",
    locale: "zh-TW",
  },
  {
    name: "zh-TW-YunJheNeural",
    gender: "male",
    displayName: "雲哲",
    locale: "zh-TW",
  },
  {
    name: "zh-TW-HsiaoYuNeural",
    gender: "female",
    displayName: "曉雨",
    locale: "zh-TW",
  },
  {
    name: "zu-ZA-ThandoNeural",
    gender: "female",
    displayName: "Thando",
    locale: "zu-ZA",
  },
  {
    name: "zu-ZA-ThembaNeural",
    gender: "male",
    displayName: "Themba",
    locale: "zu-ZA",
  },
];
